const fr = {
    common: {
        you: "Vous",
        contributor: "Contributeur",
    },
    outlookPromo: {
        skip: "Plus tard",
        later: "Continuer sans installer",
        installCta: "Installer l'extension Outlook",
        onboardingTitle: "Travaillez aussi dans Outlook",
        onboardingDescription:
            "Installez l'extension Famla pour cartographier et collaborer sans quitter votre boîte mail.",
        mappingTitle: "Votre cartographie est prête — et Outlook aussi",
        mappingDescription:
            "Installez l'extension Famla pour retrouver vos processus et signaler des points de friction directement dans Outlook.",
        interviewTitle: "Installez Famla pour Outlook",
        interviewDescription:
            "Merci pour votre contribution. L'extension Outlook Famla vous permet de continuer à collaborer depuis votre messagerie.",
    },
    dashboard: {
        addNewAdmin: "Ajouter un admin",
        addNewUser: "Ajouter un utilisateur",
        addNewAdminTitle: "Ajouter un administrateur",
        adminAddedSuccessfully: "Administrateur ajouté avec succès.",
        admin: "Administrateurs",
        andon: "Andon",
        answerDelete: "Êtes-vous sûr de vouloir supprimer définitivement cet utilisateur du système ? Cette action ne peut être annulée.",
        dashboard: "Tableau de bord",
        daysRemaining: "Nombre de jours restants",
        deleteUser: "Supprimer l'utilisateur",
        demoteFromAdmin: "Rétrograder d'administrateur",
        confirmUserDemotion: "Voulez-vous vraiment rétrograder cet administrateur en utilisateur simple ?",
        confirmAdminPromotion: "Vous êtes sur le point de promouvoir cet utilisateur au rôle d'administrateur",
        collaborators: "Collaborateurs",
        companyNotFound: "Entreprise non trouvée.",
        exitDashboard: "Fermer Dashboard",
        exportXls: "Exporter en Xls",
        lastConnectionDate: "Date de la dernière connexion",
        list: "liste",
        mappingCreationDate: "Date Création cartographie",
        monthlyTokenConsumption: "Consommation mensuelle de crédits AI",
        monthlyTokenConsumed: "Crédits AI mensuels consommés",
        promoteToAdmin: "Promouvoir au rang d'administrateur",
        processOwners: " Resp. Processus",
        remainingTokens: "Token restants",
        registrationDate: "Date d'inscription",
        shareToAll: "Partager à tous",
        shareToSelectedUser: "Partager avec certains utilisateurs",
        shareWithOtherUsers: "Partager avec des utilisateurs",
        successDemotion: "L'administrateur a été rétrogradé avec succès en utilisateur.",
        successPromotion: "L'utilisateur a été promu avec succès au rôle d'administrateur.",
        users: "Utilisateurs",
        userAlreadyAdmin: "L'utilisateur est déjà un administrateur.",
        registeredUsers: "Utilisateurs enregistrés",
        unverifiedUsers: "Utilisateurs non vérifiés",
        rootUserCannotBeRemoved: "L'administrateur principal ne peut pas être rétrogradé en utilisateur simple.",
        cannotDeleteAdmin: "Impossible de supprimer un administrateur. Veuillez d'abord le rétrograder.",
        errorDeletingUser: "Une erreur s'est produite lors de la suppression de l'utilisateur.",
        theSelectedProcessWill: "Le(s) processus sélectionné(s) sera(ont) accessible(s) à tous les utilisateurs de votre entreprise",
        theProcessSuccessfullyShared: "Le processus a été partagé avec l'utilisateur ou les utilisateurs sélectionnés.",
        totalUsers: "Total des utilisateurs",
        totalTokens: "Token",
        tokensConsumed: "Token consommés",
        // [AI CREDITS SYSTEM] Nouvelles clés pour système de crédits
        availableCredits: "Crédits disponibles",
        consumedCredits: "Crédits consommés",
        usagePercentage: "Utilisation",
        monthlyCreditConsumption: "Consommation mensuelle de crédits AI",
        currentPlan: "Plan actuel",
        readOnlyMode: "Mode Consultation",
        viewPaidPlans: "Gérer votre plan",
        viewCreditHistory: "Voir l'historique",
        enterpriseExpired: "Votre plan ENTERPRISE a expiré (crédits épuisés). Veuillez ajouter des crédits pour continuer à utiliser le service.",
        freeExpired: "Votre plan FREE a expiré (crédits épuisés). Veuillez ajouter des crédits pour continuer à utiliser le service.",
        upgradePlan: "Passer à un plan supérieur",
        enterpriseMode: "Mode Enterprise",
        proMode: "Mode Pro",
        // Nouvelles clés pour les actions de crédits
        buyMoreCredits: "Acheter plus de crédits",
        changePlan: "Changer de plan",
        myInvoices: "Mes factures",
        paymentMethods: "Moyens de paiement",
        managePlan: "Gérer mon plan",
        manageSubscription: "Gérer votre abonnement",
        manageSubscriptionMicrosoft: "Gérer via Azure Marketplace",
        manageSubscriptionMicrosoftNoUrl: "Votre abonnement est géré via Azure Marketplace. Contactez votre administrateur Azure ou le support {{appName}}.",
        // Nouvelles clés pour les statuts
        upgradePlan: "Passer à un plan supérieur",
        // [CREDITS PANEL] Nouvelles traductions pour le panneau de crédits
        freeCredits: "Crédits Gratuits",
        monthlyCredits: "Crédits Mensuels",
        topUpCredits: "Crédits Achetés",
        plusTopUpCredits: "Top up credits",
        rolloverCredits: "Roll-over",
        buyMoreCredits: "Acheter plus de Crédits",
        manageSubscription: "Gérer votre Abonnement",
        outOf: "sur",
        totalCredits: "crédits",
        unlimitedAllocation: "Allocation Illimitée",
        planStatus: "Statut",
        statusActive: "Actif",
        statusGracePeriod: "Période de grâce",
        statusExhausted: "Épuisé",
        statusExpired: "Expiré",
        gracePeriodActive: "Période de grâce active",
        // Nouvelles clés pour les types de crédits
        outOf: "sur",
        totalCredits: "crédits",
        freeCredits: "Crédits gratuits",
        monthlyCredits: "Crédits mensuels",
        topUpCredits: "Crédits achetés",
        plusTopUpCredits: "Top up credits",
        rolloverCredits: "Crédits reportés",
        consultationMode: "Mode consultation",
        statusExpired: "Expiré",
        refresh: "Actualiser",
    },

    form: {
        nameRequired: "Le nom est obligatoire",
        createCompany: {
            companyName: "Nom de l'entreprise",
            createACompany: "Créer une entreprise",
            phoneNumber: "N° de téléphone",
            postalCode: "Code postal",
            website: "Site web",
            promoCode: "Code Promo",
            promoCodePlaceholder: "Ex: GenAI.works (optionnel)"
        },
        createGroup: {
            createGroup: "Créer un dossier",
            folderNameExist: "Le nom du dossier existe déjà",
            groupCreateSuccessfully: "Création du dossier réussie",
            selectOwner: "Sélectionner un propriétaire",
            youNotAuthorized: "Vous n'êtes pas autorisé à créer un dossier"
        },
        createProcess: {
            aiLedinterview: "Interview par une IA",
            descriptionTooShort: "La description doit comporter au moins 5 caractères.",
            humanLedInterview: "Fichier texte",
            industryRequired: "L'industrie est nécessaire",
            invalidSelection: "Sélection de l'industrie invalide",
            imageBasedMapping: "Fichier image",
            nameIsNotValid: "Le nom ou la description n'est pas valide. 'Test' ou 'test' ne sont pas acceptés.",
            processCannotCreate: "le processus ne peut pas être créé par son utilisateur",
            processCreateLimite: "Limite de création atteinte – passez à Premium pour continuer.",
            processNameAlreadyExist: "Le nom du processus existe déjà dans votre compagnie",
            processOverview: "Créer un nouveau processus",
            processNamePlaceholder: "ex. Reporting financier",
            descriptionPlaceholder: "Décrivez ce que ce processus accomplit et à qui il s'adresse",
            selectIndustry: "Sélectionner un secteur d'activité",
            selectLanguage: "Sélectionner une langue d'interview",
            purposePlaceholder: "Décrivez ce que ce processus accomplit et à qui il s'adresse",
            inputMethod: "Méthode de saisie",
            interviewTextCard: "Interview (texte)",
            imageDocumentCard: "Image / document",
            submitProcess: "Créer le processus",
            tabCreate: "Créer un processus",
            tabProcesses: "Librairie"
        },
        dataCollect: {
            processOverview: "Nouvelle collection",
            subtitle: "Configurez les bases — la conversation commence juste après.",
            collectionName: "Nom de la collection",
            collectionNamePlaceholder: "ex. Reporting financier — enrichissement des données Q2",
            industryRequired: "L'industrie est nécessaire",
            functionRequired: "La fonction est nécessaire",
            industryLabel: "Secteur",
            functionLabel: "Fonction",
            selectIndustry: "Sélectionner",
            selectFunction: "Sélectionner",
            start: "Démarrer",
            functions: {
                finance: "Finance",
                hr: "Ressources Humaines (RH)",
                operations: "Opérations",
                it: "Informatique (IT)",
                sales: "Ventes",
                marketing: "Marketing",
                legal: "Juridique",
                other: "Autre"
            },
            collectionLanguageLabel: "Langue de la collecte",
            collectionLanguageHint:
                "S’applique uniquement à cette collecte (conversation de cadrage, script d’entretien, expérience contributeur, e-mails). Les collectes déjà créées sans langue enregistrée suivent le profil du responsable.",
            collectionLanguageFr: "Français",
            collectionLanguageEn: "Anglais"
        },
        collectWorkspace: {
            messageTime: {
                now: "maintenant",
                seconds: "{{count}} s",
                minutes: "{{count}} min",
                hours: "{{count}} h",
                yesterday: "Hier · {{time}}"
            },
            listenTitle: "Écouter (bientôt)",
            likeTitle: "J’aime",
            dislikeTitle: "Je n’aime pas",
            deleteLastOnly: "Seul le dernier message peut être modifié ou supprimé.",
            editLastOnly: "Seul le dernier message peut être modifié.",
            ownerSetupDeleteConfirm:
                "Supprimer ce message et tout ce qui suit dans cette conversation de configuration ? Cette action est irréversible.",
            ownerSetupDeleteFailed: "Impossible de supprimer les messages. Réessayez.",
            waitForReply: "Attendez la fin de la réponse.",
            editSave: "Enregistrer",
            editCancel: "Annuler",
            addContextModalTitle: "Joindre du contexte",
            addContextModalHint: "Fichier (PDF, texte…) et/ou cartographie de processus.",
            addContextButton: "Joindre un fichier ou une cartographie",
            contextChoiceInputLockedHint:
                "Utilisez « Joindre un fichier ou une cartographie » ou « Passer pour l'instant » ci-dessus avant de saisir du texte ou la voix.",
            contextFileEmpty: "Aucun texte n’a pu être extrait de ce fichier.",
            contextFileUnsupported: "Ce type de fichier n’est pas pris en charge. Utilisez un PDF ou du texte (.txt, .csv, .md).",
            contextFileReadError: "Lecture impossible. Essayez un autre format ou collez le texte dans l’onglet Script d’entretien.",
            contextFileWorking: "Lecture du fichier…",
            guideReviewTitle: "Réviser le script d’entretien",
            guideEmpty: "Pas encore de script d’entretien. Terminez l’échange dans Collecte ou cliquez sur « Régénérer ».",
            guideSaveFailed: "Enregistrement du script d’entretien impossible.",
            guideSectionName: "Titre de la section",
            guideSectionObjective: "Objectif de la section",
            guideQuestionRemoved: "Retirée du questionnaire",
            guideRestore: "Rétablir",
            guideHide: "Retirer du questionnaire",
            guideRegen: "Régénérer avec l’IA",
            guideRegenShort: "Régénérer la formulation",
            guideAiAdaptBanner:
                "{{appName}} adaptera la formulation des questions selon le rôle et les réponses, à partir de ce script (intentions, pas texte figé pour les destinataires).",
            deleteSection: "Supprimer la section",
            deleteSectionConfirm:
                "Supprimer toute cette section et toutes ses questions ? Cette action est irréversible.",
            guideAddQuestion: "Ajouter une question",
            guideAddSection: "Ajouter une section",
            guideNewSectionDefaultName: "Nouvelle section",
            guideAddPlaceholder: "Saisissez une nouvelle question…",
            guideDragHint: "Glisser pour réordonner les sections",
            guideMaxQuestions: "Maximum 5 questions par section.",
            guideMaxSections: "Maximum 5 sections par rôle.",
            navHome: "Accueil",
            newDataCollection: "Nouvelle collecte",
            recentDataCollections: "Récents",
            recentDataCollectionsAutoSave: "(Sauvegarde automatique)",
            recentDataCollectionsEmpty: "Aucune collecte pour l’instant.",
            recentCollectionRowMenu: "Actions sur la collecte",
            renameDataCollectionPrompt: "Nouveau nom de la collecte",
            deleteDataCollectionConfirmActive:
                "Supprimer cette collecte et toutes les réponses ? Cette action est irréversible.",
            deleteDataCollectionConfirm:
                "Supprimer ce brouillon de collecte et tout son contenu ? Cette action est irréversible.",
            withdrawMyContribution: "Supprimer pour moi",
            withdrawMyContributionConfirm:
                "Retirer votre contribution à cette collecte ? Vos réponses et messages seront supprimés. La collecte restera visible pour le propriétaire.",
            withdrawMyContributionDoneTitle: "Votre contribution a été retirée",
            withdrawMyContributionDoneBody:
                "Vos réponses et messages pour cette collecte ont été supprimés. Ce lien d’invitation n’est plus valide.",
            recipientsTitle: "Destinataires",
            noRecipients: "Pas encore de destinataires.",
            addRecipient: "Ajouter un destinataire",
            copyResponderLink: "Copier le lien répondeur",
            responderLinkCopied: "Lien copié !",
            collectInviteModalTitle: "Ajouter un répondant pour ce rôle",
            collectInviteModalSubmit: "Ajouter le contributeur",
            sharedLinkRoleTitle: "Confirmez votre rôle",
            sharedLinkRoleHint: "Choisissez le rôle qui vous correspond pour « {{name}} ».",
            sharedLinkStartInterview: "Commencer l'entretien",
            sharedLinkPickRole: "Veuillez sélectionner votre rôle.",
            sharedLinkInvalid: "Lien répondeur invalide",
            sharedLinkNotOpen: "Cette collecte n'est pas encore ouverte. Le propriétaire doit approuver le script.",
            sharedLinkNotOpenResponses: "Cette collecte n'est pas encore ouverte aux réponses.",
            sharedLinkNotApproved: "Le script d'entretien n'est pas encore approuvé.",
            sharedLinkClosed: "Cette collecte est clôturée.",
            sharedLinkInvalidRole: "Le rôle sélectionné n'est pas valide pour cette collecte.",
            sharedLinkMaxResponders: "Le nombre maximum de répondants est atteint pour cette collecte.",
            generatingGuide: "Génération du script d’entretien…",
            typeAnswer: "Saisissez votre réponse…",
            approveGuideHint:
                "Le script est approuvé.",
            activeCollectionHint:
                "La collecte est active.",
            approveRetryHint:
                "L'approbation n'a pas pu aboutir. Veuillez réessayer.",
            approvingGuide: "Approbation…",
            guideApprovedSuccess:
                "Script d'entretien approuvé. Copiez le lien répondeur ou ajoutez des destinataires quand vous êtes prêt.",
            approveAndPublishSuccess:
                "Script approuvé. La collecte est active et les invitations ont été envoyées.",
            approveAndPublishLinkSuccess:
                "Script approuvé. La collecte est active — partagez le lien répondeur avec vos répondants.",
            approveActivationPending:
                "Le script n'a pas pu être approuvé. Veuillez réessayer.",
            collectionActivatedSuccess: "Script approuvé. Les e-mails d'invitation ont été envoyés.",
            collectionActivatedLinkSuccess:
                "Script approuvé. Partagez le lien répondeur avec vos répondants.",
            approveActivationFailed:
                "La collecte n'a pas pu être activée. Veuillez réessayer.",
            contextExcerptLabel: "Extrait de contexte (optionnel)",
            contextExcerptPlaceholder: "Collez les points clés d'un document…",
            saveContext: "Enregistrer le contexte",
            regenerateGuide: "Régénérer le script d’entretien (IA)",
            setupNotReadyForScript:
                "Terminez le cadrage dans l’onglet Collecte (objectif, contexte ou cartes, et rôles) avant de générer ou d’approuver le script d’entretien.",
            setupNotReadyShort: "Terminez d’abord le cadrage dans Collecte.",
            setupNotReadyHint:
                "Répondez aux questions de cadrage restantes (objectif, contexte et rôles) avant de pouvoir approuver.",
            guideGenerationFailed: "Échec de la génération du script d’entretien",
            approveGuide: "Approuver le script",
            contributorsTitle: "Contributeurs",
            selectContributor: "Sélectionnez un contributeur.",
            transcriptTitle: "Transcription",
            checklistTitle: "Votre checklist",
            quickActionsTitle: "Actions rapides",
            viewAsRecipient: "Aperçu comme destinataire",
            recipientPreviewBadge: "Aperçu",
            recipientPreviewBanner:
                "Aperçu — entretien guidé par l’IA (relances, regroupement de thèmes). Rien n’est enregistré.",
            recipientPreviewSimulatedRole: "Rôle simulé",
            recipientPreviewCustomRole: "Ou saisir un rôle…",
            recipientPreviewRestart: "Relancer l'aperçu",
            recipientPreviewIntroOpening:
                "Nous sommes ravis de vous accueillir. Pour **{{name}}**, {{appName}} vous accompagne pas à pas dans le script d'entretien — comme pour les contributeurs une fois la collecte en ligne.",
            recipientPreviewObjective: "Objectif",
            recipientPreviewQuestionLine: "Question {{n}} sur {{total}}",
            recipientPreviewNextThanks: "Merci. Voici la question suivante.",
            recipientPreviewDone:
                "**Vous avez parcouru la dernière question de ce guide.** En production, {{appName}} poursuit ici la conversation avec chaque contributeur. Utilisez **Fermer** ci-dessus pour revenir à l'espace collecte et envoyer les invitations quand vous êtes prêt.",
            recipientPreviewCloseHint: "Retour à l'espace de la collecte",
            recipientPreviewExportHeader:
                "Aperçu — export texte uniquement (les contributeurs obtiennent un export XLSX depuis {{appName}}).",
            recipientPreviewEmptyGuide:
                "Générez d'abord le script d'entretien avec au moins une question conservée, puis vous pourrez prévisualiser l'expérience destinataire.",
            recipientPreviewNoQuestionsForRole:
                "Aucune question conservée pour ce rôle. Choisissez un autre rôle dans la liste ou vérifiez le script d'entretien.",
            recipientPreviewLoadError: "Impossible de charger cette collecte pour l'aperçu.",
            recipientPreviewBackToWorkspace: "Retour à la collecte",
            publish: "Publier",
            shareLink: "Copier le lien répondant",
            openSynthesis: "Ouvrir les réponses",
            viewInterviewScript: "Voir le script d’entretien",
            viewInterviewScriptEmpty: "Générez ou approuvez d’abord le script d’entretien.",
            exportTranscripts: "Exporter le script d’entretien",
            exportGuideNeedApproved: "Approuvez le script d’entretien avant de l’exporter en PDF.",
            exportGuidePdfTitle: "Script d’entretien approuvé",
            exportGuideApprovedStamp: "Approuvé le {{date}}",
            exportGuideQuestionPrefix: "Q",
            openSettings: "Ouvrir les paramètres",
            settingsModal: {
                title: "Paramètres de la collecte",
                interviewEnd: "Date de fin de l’entretien",
                interviewEndHint: "Échéance facultative pour terminer les entretiens de cette collecte.",
                reminderFrequency: "Fréquence des e-mails de rappel",
                reminder6h: "6 h après l’invitation",
                reminder12h: "12 h après l’invitation",
                reminder24h: "24 h après l’invitation",
                reminder48h: "48 h après l’invitation",
                reminder72h: "72 h après l’invitation",
                reminder168h: "7 jours après l’invitation",
                recipientsCanInvite: "Les destinataires peuvent inviter d’autres destinataires",
                anonymousResponses: "Réponses anonymes",
                anonymousResponsesHint:
                    "Les contributeurs apparaissent sous des noms fictifs (animaux ou étoiles). Vous ne pouvez pas savoir qui se cache derrière chaque nom.",
            },
            settingsInvalidDate: "Date invalide",
            announcementsTitle: "Annonces",
            copyLinkError: "Ajoutez d'abord un contributeur pour obtenir un lien d'invitation.",
            copyLinkFail: "Impossible de copier le lien.",
            owner: "Propriétaire",
            collectionLead: "Responsable de collecte",
            participants: "Participants",
            contributorOnlineNow: "En ligne",
            contributorOnlineNowEmpty: "Aucun autre contributeur n’apparaît comme en ligne pour le moment.",
            contributorOthers: "Autres",
            contributorOnlyYouInList: "Pas d’autres participants pour l’instant.",
            contributorYouPinned: "Vous",
            contributorDefaultRole: "Contributeur",
            contributorStatusNotStarted: "Pas commencé",
            contributorYourProgress: "Votre avancement",
            contributorProgressStepCount: "{{done}} / {{total}}",
            contributorProgressStepsHint: "{{done}} étapes terminées sur {{total}}",
            contributorSectionCompleted: "{{count}} questions · terminé",
            contributorSectionPartial: "{{answered}} / {{total}} questions · en cours",
            contributorQuestionProgress: "Question {{n}} sur {{total}} · {{section}}",
            contributorThemesProgress: "{{covered}} / {{total}} thèmes couverts · {{section}}",
            monitorGuideIntentLabel: "Intention du script",
            contributorShareCopied: "Lien copié dans le presse-papiers",
            contributorInviteToCollection: "Inviter à la collecte",
            contributorQuickCreateAccount: "Créer un compte {{appName}}",
            contributorQuickRecommendFriend: "Recommander {{appName}} à un proche",
            contributorRecommendShareTitle: "{{appName}}",
            contributorRecommendShareText:
                "Découvrez {{appName}} pour la recherche qualitative et les entretiens : {{url}}",
            contributorRecommendEmailSubject: "Je pense que {{appName}} pourrait t’intéresser",
            contributorRecommendEmailBody:
                "Bonjour,\n\nJ’utilise {{appName}} pour mes entretiens et ma recherche qualitative — voici le lien pour créer un compte :\n{{url}}\n",
            contributorInviteHelp:
                "Pour inviter d’autres personnes, demandez au responsable de la collecte d’ajouter des contributeurs depuis son espace {{appName}}.",
            inviteAnotherRecipient: "Inviter un autre destinataire",
            sendInvitation: "Envoyer l’invitation",
            recipientInviteSending: "Envoi en cours…",
            recipientInviteValidation: "Le nom, l’e-mail et le rôle sont obligatoires.",
            recipientInviteFailed: "L’invitation n’a pas pu être envoyée. Réessayez.",
            recipientInviteSuccess: "Invitation envoyée avec succès.",
            connectionError: "Erreur de connexion",
            recipientInviteSelfEmail: "Vous ne pouvez pas inviter votre propre adresse e-mail.",
            liveSession: "En cours",
            inProgress: "En cours",
            collectionBadgeDraft: "Brouillon",
            collectionBadgeActive: "Active",
            collectionBadgeClosed: "Fermée",
            errorPublishNeedContributors:
                "Ajoutez au moins un contributeur avant d'approuver le script et d'envoyer les invitations.",
            errorCtaAddRecipient: "Ajouter un destinataire",
            inviteContributorsHint: "Ajoutez au moins un contributeur pour envoyer les invitations.",
            publishAfterInviteFailed:
                "Les contributeurs ont été ajoutés mais le script n'a pas pu être approuvé. Réessayez.",
            duplicateContributorRole: "{{email}} est déjà invité pour ce rôle.",
            recipientReminderSent: "E-mail de rappel envoyé.",
            deleteContributorConfirm: "Retirer {{name}} de cette collecte ? Cette action est irréversible.",
            replaceContributorConfirm:
                "Remplacer {{name}} ? Il sera retiré de la liste et vous pourrez en ajouter un autre.",
            recipientRowMenu: "Actions destinataire",
            confidentialityNote: "Vos réponses sont confidentielles pour le responsable de la collecte.",
            contributorDraftInputDisabled:
                "Cette collecte est encore en préparation. Vous pourrez répondre dès qu'elle sera activée par le responsable.",
            loadingSession: "Chargement de votre session sécurisée…",
            redirectingToSignIn:
                "Ouverture de la connexion pour accéder à cette contribution avec votre compte {{appName}}…",
            thankYouTitle: "Merci pour votre contribution !",
            thankYouBody: "Vos réponses ont été enregistrées en toute sécurité. Vous pouvez maintenant exporter votre transcription.",
            collectionEndedBadge: "Collecte terminée",
            collectionEndedModalTitle: "Cette collecte est terminée",
            collectionEndedModalBodyClosed:
                "Le responsable a fermé cette collecte.",
            collectionEndedModalBodyDeadline:
                "La date limite de cette collecte est dépassée.",
            collectionEndedModalOk: "OK",
            completedPlaceholder: "Conversation terminée",
            typeMessage: "Saisissez votre réponse ici...",
            quickActions: "Actions rapides",
            exportTranscript: "Exporter ma transcription",
            privacy: "Confidentialité",
            privacyText: "Cette conversation est privée entre vous et le responsable de la collecte. Vos réponses individuelles ne sont pas visibles par les autres participants.",
            privacyTextAnonymousLine1:
                "Vos réponses restent privées. Le responsable ne les voit qu’associées à un nom fictif",
            privacyTextAnonymousLine2:
                "et ne peut pas relier ce nom à votre identité. Les autres participants ne voient pas vos réponses.",
            anonymousBadge: "Anonyme",
            anonymousBadgeTitle:
                "Vos réponses sont présentées au responsable sous un nom fictif ; il ne peut pas savoir qui vous êtes.",
            anonymousSessionNote:
                "Cette collecte est anonyme : le responsable ne voit qu’un nom fictif par participant, pas qui vous êtes.",
            checklist: {
                obj: {
                    label: "Définir l'objectif",
                    detailDone: "Capturé depuis le chat",
                    detailPending: "Répondez à la première question"
                },
                ctx: {
                    label: "Ajouter du contexte",
                    detailSkipped: "Ignoré",
                    mapsOne: "1 cartographie",
                    mapsMany: "{{count}} cartographies",
                    docOne: "1 document",
                    detailJoinSeparator: " · ",
                    detailDoneGeneric: "Contexte enregistré",
                    detailPending: "Fichier ou cartographie (optionnel)"
                },
                guide: {
                    label: "Réviser le script d’entretien",
                    detailGenerating: "Génération…",
                    detailApproved: "Approuvé",
                    detailReady: "Action requise",
                    detailPending: "En attente de configuration",
                    detailSetupBlocked: "Terminez le cadrage dans Collecte avant d’approuver le script.",
                },
                rec: {
                    label: "Ajouter des destinataires",
                    detailDone: "{{count}} ajouté(s)",
                    detailPending: "Parties prenantes qui répondront"
                },
                interviews: {
                    label: "Entretiens terminés",
                    detailProgress: "{{completed}} sur {{total}} terminés"
                }
            }
        },
        collectResults: {
            backToWorkspace: "Retour",
            exportXlsx: "Exporter XLS",
            responseBadge: "{{done}} / {{total}} réponses",
            tabSummary: "Tableau de bord",
            tabTable: "Tableau",
            insightsCta: "Analyser dans Insights",
            statResponses: "Réponses",
            statResponsesSubAll: "100 % complétées",
            statResponsesSubPartial: "{{pct}} % complétées",
            statQuestionsCovered: "Questions couvertes",
            statQuestionsSub: "sur {{total}} dans le script d’entretien",
            statAvgLead: "Délai moyen",
            statAvgLeadSub: "sur toutes les étapes",
            statAvgLeadEmpty: "—",
            responsesCountLabel: "{{count}} réponses",
            noSynthesisYet:
                "Pas encore de réponses. Lorsque les répondants auront terminé l'entretien, vous pourrez générer un tableau de bord interactif ici.",
            tableEmpty: "Aucune réponse à comparer pour l’instant.",
            tableLoadError: "Impossible de charger le tableau comparatif.",
            respondentCol: "Répondant",
            guideSectionFallback: "Script d’entretien",
            dashboardTitle: "Tableau de bord interactif",
            dashboardBody:
                "Les graphiques IA de cette collecte s’afficheront ici. Utilisez le bouton Analyse pour ouvrir Insights et des rapports approfondis.",
            dashboardCreditsNotice: "Chaque génération du tableau de bord coûtera {{credits}} crédits IA.",
            dashboardRadarHint:
                "Vos données peuvent permettre un diagramme radar — l’IA décidera lors de la création du tableau de bord.",
            dashboardGenerate: "Générer le tableau de bord ({{credits}} crédits)",
            dashboardRegenerate: "Régénérer",
            dashboardGenerating: "Génération du tableau de bord…",
            dashboardLoading: "Chargement du tableau de bord…",
            dashboardStale: "Les données de la collecte ont changé depuis la dernière génération.",
            dashboardGenerateError: "Impossible de générer le tableau de bord. Réessayez.",
            dashboardProviderBilling:
                "Le fournisseur IA (OpenAI) n'a plus de quota ou crédits. Rechargez sur platform.openai.com ou contactez le support {{appName}}.",
            dashboardProviderAuth:
                "Clé API OpenAI invalide. Vérifiez la variable OPENAI sur le serveur API."
        }
    }
    ,

    features: {
        swimlane: {
            accessGranted: "Accès accordé",
            addRowUp: "Ajouter une ligne vers le haut",
            addRowDown: "Ajouter une ligne en bas",
            moveRowUp: "Déplacer la ligne vers le haut",
            moveRowDown: "Déplacer la ligne vers le bas",
            addDocument: "Ajouter un document",
            approveQuestion: "Êtes-vous sûr de vouloir approuver ce diagramme ?",
            arrowsAttributes: "Attributs des flèches",
            warnings: "Alertes",
            analysis: "Analyse",
            analyzeAllAttributesData: "Une vue complète de la structure, des rôles, des étapes et des indicateurs clés",
            analyzeLead: "Temps d'exécution par étape — où la durée s'accumule dans le processus",
            analysisName: "Nom de l'analyse",
            bottleneckIdentification: "Où le travail est-il bloqué ?",
            collaboratorAccessManagement: "Gestion des accès collaborateurs",
            ctrlMouseWheel: "MoletteSouris",
            deleteRow: "Supprimer la ligne",
            deleteAnalysis: "Supprimer l'analyse",
            deleteAnalysisConfirm: "Êtes-vous sûr de vouloir supprimer cette analyse ?",
            disableEditMode: "Désactiver le mode édition",
            disaableMapEdit: "Désactiver l'édition de la cartographie",
            disaableDataEdit: "Désactiver l'édition des données",
            disApproveQuestion: "Êtes-vous sûr de vouloir désapprouver ce diagramme ?",
            doYouwantSaveave: "Souhaitez-vous enregistrer les modifications apportées au diagramme avant de quitter ?",
            editableAttrinbutesConfiguration: "Configuration des attributs modifiables",
            dontLikeReport: "Je n'aime pas ce rapport",
            enableEditMode: "Editer la cartographie",
            enableMapEdit: "Activer l'édition de la cartographie",
            enableDataEdit: "Activer l'édition des données",
            enterYourPrompt: "Posez n'importe quelle question sur votre processus",
            enterAnalysisName: " Entrez le nom de l'analyse",
            exportPDF: "Exporter en PDF",
            exportPNG: "Exporter en PNG",
            exportCSV: "Exporter en CSV",
            exportXES: "Exporter en XES",
            examineDefect: "Étapes sujettes aux erreurs, taux de défauts et lacunes de conformité",
            famlaMake: "{{appName}} peut faire des erreurs. Vérifiez les résultats importants.",
            feedbackPlaceholder: "Dites-nous ce que nous pouvons améliorer...",
            fontSize: 'Police',
            giveAccess: "Donner l'accès",
            helpful: "Noter cette cartographie",
            howCanHelpYouToday: "Entrez un prompt pour générer une analyse détaillée en quelques instants.",
            hideElements: "Masquer les éléments",
            hideLayers: "Masquer les Attributs",
            improvSentence: " Nous nous associons à des leaders de l'industrie pour accompagner votre parcours d'amélioration unique. - Disponible bientôt.",
            identifyStakeholders: "Étapes causant des retards, boucles de retravail ou transferts inutiles",
            likeReport: "J'aime ce rapport",
            leadTimeAnalysis: "Où le temps est-il perdu ?",
            mapSaveWithSucess: "Diagramme sauvegardée avec succès",
            makeCopy: "Créer une copie",
            copySuffix: "copie",
            copyCreated: "Copie créée avec succès",
            linkAttributesPrompt: "Choisissez les attributs",
            addSheet: "Ajouter une feuille",
            allSheets: "Toutes les feuilles",
            hiddenSheets: "Feuilles masquées",
            hideSheet: "Masquer la feuille",
            showSheet: "Afficher la feuille",
            moveSheetLeft: "Déplacer à gauche",
            moveSheetRight: "Déplacer à droite",
            renameSheetPrompt: "Nouveau nom de la feuille",
            deleteSheetConfirm: "Supprimer cette feuille ?",
            deleteSheetConfirmDetailed: "Vous allez supprimer la feuille \"{{name}}\". Cette action est irréversible.",
            sheetCreated: "Nouvelle feuille créée",
            sheetRenamed: "Feuille renommée avec succès",
            sheetDeleted: "Feuille supprimée",
            sheetDeletedDetailed: "La feuille \"{{name}}\" a été supprimée avec succès.",
            sheetDeleteFailed: "Impossible de supprimer la feuille \"{{name}}\". Veuillez réessayer.",
            cannotDeleteLastSheet: "Impossible de supprimer la dernière feuille",
            cannotDeleteLastSheetDetailed: "Impossible de supprimer la dernière feuille. Ajoutez d'abord une autre feuille.",
            untitledSheet: "Sans titre",
            newSheetDefaultName: "Feuille",
            sheetSwitching: "Chargement de la feuille…",
            sheetSwitchingNamed: "Chargement de {{name}}…",
            mapExist: "Ce nom est déjà utilisé pour une autre cartographie. Essayez avec un nom différent.",
            moveToBin: "Move to Bin",
            newAnalysis: "Nouvelle analyse",
            newDocument: "Nouveau document",
            newInsight: "Nouvel insight",
            addProcess: "Ajouter un processus",
            processes: "Processus",
            recentInsights: "Insights récents",
            noProcessesLinked: "Aucun processus lié. Ajoutez-en un pour obtenir des insights.",
            noAccess: "Sans accès",
            noDocuments: "Aucun document",
            selectedDocuments: "Documents sélectionnés",
            selectMapFirst: "Veuillez sélectionner au moins une carte",
            errorLoadingAnalysis: "Impossible de charger l'analyse",
            unsavedAnalysis: "Analyse non sauvegardée",
            unsavedAnalysisMessage: "Vous avez une analyse en cours non sauvegardée. Voulez-vous la sauvegarder avant de créer une nouvelle analyse ?",
            unsavedAnalysisLeaveMessage: "Vous avez une analyse en cours non sauvegardée. Voulez-vous la sauvegarder avant de quitter cette page ?",
            unsavedDraft: "Brouillon non sauvegardé",
            unsaved: "Non sauvegardé",
            unsavedChanges: "Modifications non sauvegardées",
            cancel: "Annuler",
            discardAnalysis: "Ignorer",
            saveAndContinue: "Sauvegarder",
            saveAnalysis: "Sauvegarder l'analyse",
            analysisName: "Nom de l'analyse",
            analysisNameRequired: "Le nom de l'analyse est requis",
            analysisNameAlreadyExists: "Vous avez déjà une analyse avec ce nom. Choisissez un autre nom.",
            errorSavingAnalysis: "Erreur lors de la sauvegarde",
            saveAnalysisHint: "Cette analyse sera accessible depuis « {{section}} » dans la barre latérale.",
            saving: "Sauvegarde...",
            save: "Sauvegarder",
            continueWithoutSaving: "Voulez-vous continuer sans sauvegarder ?",
            continueWithoutSavingLeave: "Voulez-vous quitter sans sauvegarder ?",
            leaveWithoutSaving: "Quitter sans sauvegarder",
            saveAnalysisTip: "Utilisez le bouton",
            saveAnalysisTip2: "sur vos rapports pour les enregistrer.",
            ignoreAndContinue: "Ignorer et continuer",
            noReportsMatchSearch: "Aucun rapport n'a été trouvé.",
            noSavedReports: "Pas de rapports sauvegardés.",
            noInformation: "Aucune information n'a été trouvée pour ce bloc. La référence n'a peut-être pas été trouvée",
            oops: "Oups ! Quelque chose n'a pas fonctionné",
            oopsSomething: " Oups, un petit problème est survenu pendant la sauvegarde. Cela peut être lié à la structure des données. Réessayez dans un instant.",
            openInterview: "Retour au chatbot",
            open: "Ouvrir",
            onboardingTutorial: "Tutoriel d'intégration",
            pleaseWait: "Le diagramme est en cours de chargement. Il devrait être prêt dans quelques secondes",
            properties: "Barre d’outils",
            processOwner: " Responsable de processus",
            prompt1: "Veuillez analyser toutes les données relatives aux attributs et fournir un résumé des principales informations pour chaque attribut, en mettant en évidence les modèles et les tendances significatifs.",
            prompt2: "Analyser les données relatives aux parties prenantes afin d'identifier celles dont le retard est le plus important et dont les délais d'action sont les plus longs. Utiliser les irritants et les données d'amélioration pour suggérer des améliorations ciblées des performances.",
            prompt3: "Examiner les données relatives aux attributs des délais, fournir une analyse détaillée et proposer des actions d'amélioration sur la base des irritants identifiés et des améliorations potentielles.",
            prompt4: "Analyser les données relatives au taux de défaillance, fournir des informations sur les tendances en matière de qualité et recommander des mesures d'amélioration sur la base des problèmes identifiés et des possibilités d'amélioration.",
            compareProcesses: "Comparer les processus",
            compareMultipleProcesses: "Comparez les processus sélectionnés pour identifier les différences.",
            promptCompareProcesses: "Comparez les processus que j'ai sélectionnés et identifiez leurs principales différences et similitudes.",
            identifyBottlenecks: "Identifier les goulots d'étranglement",
            findCommonBottlenecks: "Trouvez les goulots d'étranglement communs dans les processus sélectionnés.",
            promptBottlenecks: "Identifiez les goulots d'étranglement communs dans les processus sélectionnés et proposez des solutions.",
            analyzeEfficiency: "Analyser l'efficacité",
            compareEfficiencyMetrics: "Comparez les métriques d'efficacité entre les processus.",
            promptEfficiency: "Comparez les métriques d'efficacité (temps, coûts, qualité) entre les processus sélectionnés.",
            bestPractices: "Meilleures pratiques",
            identifyBestPractices: "Identifiez les meilleures pratiques à partager.",
            promptBestPractices: "Identifiez les meilleures pratiques dans les processus sélectionnés qui peuvent être appliquées aux autres.",
            selectAtLeastOneProcess: "Veuillez ajouter au moins un processus à analyser en cliquant sur le bouton \"+\"",
            qualityAnalysis: "Où se produisent les erreurs et retravaux ?",
            removeAccess: "Retirer l'accès",
            redo: "Rétablir",
            reportAbug: "Signaler un bug",
            reportGenerate: "Que voulez-vous apprendre sur ce processus ?",
            reportsDescription: "Sélectionnez un processus pour explorer ses cartographies.",
            scope: "Périmètre d'analyse",
            shareYourFeedback: "Faites-nous part de votre avis",
            showLayers: "Afficher les Attributs",
            saveFileAs: "Enregistrer le fichier sous",
            saveAnalysis: "Enregistrer l'analyse",
            selectAll: "Tout sélectionner",
            fitBlocksToContent: "Ajuster au contenu",
            resetBlocksContentFit: "Réinitialiser l'ajustement au contenu",
            selectMap: "Ajouter une cartographie",
            selectDataCollection: "Ajouter des données d'enquête",
            collectLinkNeedsResponses:
                "Cette collecte n'a pas encore de réponse contributeur. Au moins une interview complétée est requise pour l'ajouter à l'analyse.",
            selectedForAnalysis: "Éléments sélectionnés",
            shapes: "Formes (glisser-déposer)",
            addTextAnnotation: "Ajouter une annotation textuelle",
            bpmn: {
                textAnnotation: "Annotation textuelle",
            },
            // eslint-disable-next-line no-template-curly-in-string
            s1: "Responsable de processus, vous avez économisé {{time}} précieuses minutes d'entretiens grâce à {{appName}} !",
            // eslint-disable-next-line no-template-curly-in-string
            s2: "{{time}} minutes d’entretien et de dessin économisées ! {{appName}} accompagne les responsables de processus comme vous.",
            // eslint-disable-next-line no-template-curly-in-string
            s3: "{{time}} minutes d’entretien et de dessin en moins. Responsable de processus, {{appName}} simplifie votre travail.",
            stakeholder: 'Contributeur',
            sucessApprov: "Succès ! Le diagramme a été approuvé avec succès.",
            summaryStatistics: "Comment mon processus performe-t-il globalement ?",
            sucessDisapprov: "Succès ! Le diagramme a été rejeté avec succès.",
            suggestions: "Suggestions",
            swimlaneNameIsNandatory: "le nom du diagramme est obligatoire",
            tasksAttributes: 'Attributs de tâches',
            warningSingleConnection: "Connexion unique",
            warningsLoading: "Chargement des alertes…",
            warningOneSidedFlow: "Flux à sens unique",
            warningStakeholderMismatch: "Cette tâche a été soumise par quelqu'un d'autre que le responsable.",
            undo: "Retour",
            uploadFile: "Télécharger un fichier",
            versionHistory: "Toutes les feuilles",
            Renamesheet: "Renommer Feuille",
            verifInfo: "Vérifier les informations de la cartographie",
            verificationSourceTitle: "Source",
            verificationUnavailableTitle: "Source",
            verificationOnlyAiOrUpload:
                "Cette commande n'est disponible que pour les diagrammes générés automatiquement à partir d'entretiens IA ou de documents importés",
            verificationNotAvailableImage:
                "Cette fonction n'est pas disponible lorsque la cartographie a été construite à partir d'une image ou d'un fichier.",
            verificationHumanIntro:
                "Voici les passages de l’entretien qui ont été rapprochés de l’étape sélectionnée dans le diagramme.",
            verificationDiagramStepLabel: "Étape du diagramme concernée",
            verificationExcerpt: "Extrait {{n}}",
            verificationSourceText: "Texte source",
            WeSorry: "Nous n'avons pas pu afficher votre diagramme swimlane en raison d'un problème technique, tel qu'une erreur de connectivité réseau, un incident serveur ou un formatage incorrect des données. Pour revenir au chatbot et permettre la régénération automatique du diagramme, veuillez cliquer sur 'Rafraîchir' et patienter pendant le processus de reconstitution.",
            yourChangesWereNotSaved: "Votre modification n'a pas été enregistrée. Nous vous invitons à actualiser la page et à réessayer.",
            autoSavePending: "Modification non sauvegardée",
            autoSaveSaving: "Sauvegarde en cours...",
            autoSaveSaved: "Toutes les modifications sont sauvegardées",
            autoSaveError: "Erreur lors de la sauvegarde",
            participantsOnline: "participant(s) en ligne",
            userJoinedMap: "a rejoint la carte",
            userLeftMap: "a quitté la carte",
            wsConnected: "Sauvegarde automatique activée",
            wsDisconnected: "Déconnecté",
            online: "En ligne",
            readOnlyMap: "Vous n'avez pas les droits de modification sur cette carte",
            mapGenTitle: "Génération de votre cartographie en cours…",
            mapGenSubtitle: "Nous vous notifierons lorsque votre carte sera prête",
            mapGenStep1: "Analyse des données d'entretien…",
            mapGenStep2: "Dessin du flux…",
            mapGenStep3: "Finalisation de la mise en page…",
            mapGenCountdown: "Temps estimé restant : {{mm}}:{{ss}}",

        }
    },

    navigation: {
        addAnotherEmail: "Ajouter un autre e-mail",
        allRightsReserved: "Tous droits réservés.",
        allFieldsRequired: "Tous les champs avec (*) sont obligatoires.",
        anErrorOcured: "Une erreur s'est produite, veuillez réessayer plus tard",
        anErrorOccurred: "Une erreur s'est produite, veuillez réessayer plus tard",
        anErrorOcuredProcessNotFund: "Le processus n'a pas été trouvé.",
        anErrorOccurredMappNotFound: "La map n'a pas été trouvée",
        assigningProcessFolder: "Assigner un processus à un dossier",
        approvalCannotCreateByUser: "Vous ne pouvez pas inviter à approuver en tant que collaborateur.",
        backHome: "Revenir à l'accueil",
        backToDashboard: "Retour au Dashboard",
        backToFamla: "Retour sur {{appName}}",
        contactUs: "Contactez-nous",
        deleteConfirmation: "Confirmation de suppression",
        diagramName: "Nom du diagramme",
        diagramsPendingApproval: "Diagrammes en attente d'approbation",
        enterRole: "Entrer un rôle",
        enterFolderName: "Entrez un nom de dossier",
        enterProcessName: "Entrez un nom de processus",
        enterValideEmail: "Ajouter au moins un e-mail",
        enterAtLeastOneEmail: "Add at least one e-mail",
        enterEmailOrPhone: "Ajoutez au moins un e-mail ou un numéro WhatsApp",
        whatsappPhone: "Téléphone WhatsApp (E.164)",
        whatsappOptionalHint: "Optionnel : inviter via WhatsApp (numéro avec indicatif, ex. +33...)",
        whatsappConsentLabel: "Je confirme que le contributeur a accepté de recevoir des messages WhatsApp",
        whatsappConsentRequired: "Le consentement WhatsApp est requis pour une invitation par téléphone",
        addAnotherPhone: "Ajouter un autre numéro",
        whatsappInProgress: "En cours sur WhatsApp",
        whatsappSupervisionHint: "Cet entretien se déroule sur WhatsApp. L'historique est en lecture seule ici.",
        phoneUpdated: "Numéro de téléphone mis à jour",
        editPhone: "Modifier le numéro de téléphone",
        fileSize: "Trop lourd (10 Mo max)",
        fileAlreadySelected: "Ce fichier est déjà sélectionné",
        folderSuccessfully: "Dossier mis à jour avec succès.",
        folderNotFound: "Erreur : Le dossier n'a pas été trouvé",
        interviewNotOver: "L'interview n'est pas terminée",
        inviteOwner: "Inviter vos coéquipiers à vous rejoindre",
        inviteAApprover: "Inviter un approbateur",
        inviteCollaborator: "Inviter un contributeur",
        inviteYourTeammates: "Inviter vos coéquipiers",
        invitationSentSuccessfully: "Invitation envoyée avec succès",
        loading: "Chargement...",
        logOut: 'Se déconnecter',
        markAsFinal: "Marquage final",
        mapWithNotFound: "Une erreur s'est produite : La map n'a pas été trouvée.",
        switchingCompany: "Changement de compagnie...",
        noData: "Aucune donnée",
        noMatchingResults: "Aucun résultat correspondant",
        noRequest: "Aucune demande d'approbation",
        privacyHub: 'Politique de confidentialité',
        shareLink: "Partager le lien",
        skipThisStep: "Ignorer cette étape",
        searchAmap: "Rechercher une cartographie",
        selectFolder: "Sélectionner un dossier",
        selectRole: 'Sélectionner un rôle',
        sendInvitations: "Envoyer des invitations",
        sending: "Envoi en cours",
        successfullyUpdated: "Mise à jour effectuée avec succès",
        transcript: 'Telecharger le transcript',
        termsOfUse: "Conditions d'utilisation",
        theProcessHasBeenHalted: "Le processus a été arrêté avec succès.",
        time_remaining: "Temps restant : {{count}} jour{{count, plural, one {} other {s}}}",
        timeSaved: "Total du temps économisé",
        userGuide: "Guide d'utilisation",
        oops: " Oups ! La page n'a pas été trouvée",
        privacyPolicy: "Politique de confidentialité",
        process: "Processus",
        processName: "Nom du processus",
        processchange: "Le processus ne peut être modifié qu'une fois qu'il est terminé.",
        processClassifiedWithSuccess: "Processus classé avec succès",
        processCannot: "Vous ne pouvez pas mettre à jour ce processus.",
        processNotFound: "Le processus n'a pas pu être trouvé.",
        proJectNotFound: "Le project n'a pas pu être trouvé.",
        processSuccessfully: "Processus mis à jour avec succès.",
        publishQuestion: "Marquer comme final ? Cela rendra le processus en lecture seule et empêchera toute modification ultérieure.",
        proTip: "Astuce",
        proTipSmalltext: " Faites participer vos collègues et découvrez la vraie puissance de la cartographie collaborative des processus !",
        roleAlreadyExist: "Le rôle existe déjà",
        roleNotFound: "Une erreur s'est produite. Le rôle n'a pas été trouvé",
        simplyLeverage: "Vous pouvez également vous appuyer sur l'expertise de notre équipe.",
        sendReminder: "Envoi rappel",
        termsAndConditions: "Conditions d'utilisation",
        textProtip: "Utiliser {{appName}} tout seul, c’est un peu comme parler tout seul sur les réseaux sociaux - pas très utile, ni très marrant",
        youAreNotLoggedIn: "Vous n'êtes pas connecté ",
        youAreNotAuthorized: "Vous n'êtes pas autorisé à mettre à jour ce dossier.",
        youAreNotAuthorizedToPerformThisAction: "Vous n'êtes pas autorisé à effectuer cette action."
    }
    ,

    layout: {
        header: {
            approvalRequests: "Demandes d'approbation",
            upgradeToPremium: "Choisir un plan - {{daysRemaing}} jour restant",
            upgradeToPremiums: "Choisir un plan - {{daysRemaing}} jours restant",
            upgradeToPrem: "Choisir un plan",
            updateCompany: "Voir l'entreprise",
            company: 'Entreprises',
            changeCompany: "Changer d’entreprise",
            selectCompany: "Sélectionner une entreprise mettra à jour votre session et rechargera l'application.",
            brandAlt: "{{appName}}",
            menuToggle: "Afficher ou masquer le menu",
            planUnknown: "—",
            planFREE: "Gratuit",
            planESSENTIAL: "Essentiel",
            planPLUS: "Plus",
            planENTERPRISE: "Entreprise",
            langShortEN: "EN",
            langShortFR: "FR",
            shortcutMac: "⌘K",
            shortcutWin: "Ctrl+K",
            roleAdmin: "Administrateur",
            roleUser: "Utilisateur",
            userMenuNav: "Menu du compte utilisateur"
        }
    },

    views: {
        analysis: {
            title: "Analyse de Processus IA",
            subtitle: "Sélectionnez un processus pour l'analyser",
            noProcesses: "Aucun processus disponible",
            createFirstProcess: "Créez votre premier processus pour commencer l'analyse",
            lastUpdated: "Dernière mise à jour",
            analyze: "Analyser",
            analyzing: "Analyse en cours",
            
        },
        auth: {
            accountAlreadyExist: "Compte existant",
            inviteExistingAccountUseLogin: "Un compte existe déjà avec cet e-mail. Connectez-vous pour continuer.",
            alreadyHaveAccount: "Vous avez déjà un compte ?",
            anErrorOcured: "Une erreur s'est produite, veuillez réessayer plus tard",
            amazingFeatures: "Vous n'êtes qu'à un clic pour découvrir des fonctionnalités étonnantes !",
            compagnyNameIsRequired: "Le nom de l'entreprise est obligatoire",
            continueWithApple: "Continuer avec Apple",
            continueWithGoogle: "Continuer avec Google Workspace",
            googleSsoProOnly: "La connexion Google est réservée aux adresses email professionnelles. Les emails personnels (Gmail, Yahoo, etc.) ne sont pas autorisés. Veuillez utiliser une adresse professionnelle ou créer un compte avec email/mot de passe.",
            continueWithMicrosoft: "Continuer avec Microsoft",
            or: "OU",
            continueWithST: "Continuer avec STMicroelectronics",
            stWelcomeMessage: "Connectez-vous avec votre compte STMicroelectronics pour accéder à {{appName}}",
            stSecurityMessage: "Connexion sécurisée via le système d'authentification STMicroelectronics",
            stSsoErrorTitle: "Échec de la connexion SSO ST",
            stSsoErrorFallback: "La connexion via STMicroelectronics a échoué. Veuillez réessayer.",
            clicking: "Veuillez vérifier votre adresse électronique en cliquant sur le lien figurant dans votre boîte de réception.",
            dontHaveAccount: "Vous n'avez pas de compte ?",
            enterValidMail: "Entrez un e-mail professionnel valide",
            eliminate: "Éliminer les gaspillages, réduire les coûts et maximiser les profits grâce aux méthodologies Lean Six Sigma éprouvées.",
            emailAddres: "Adresse e-mail",
            emailAddresPro: "Adresse e-mail professionnelle",
            emailIsRequired: "L'e-mail est obligatoire",
            emailAddressIs: "L'adresse e-mail est incorrecte ou n'existe pas",
            establish: "Établir des rôles et des responsabilités clairs, éliminer l'ambiguïté, optimiser la collaboration et favoriser la réussite de l'équipe.",
            forgotPassword: "Mot de passe oublié ?",
            famlaTeam: "Équipe {{appName}} ",
            getStarted: "Commencer",
            getStartedForFree: "Commencer gratuitement",
            hi: "Salut",
            incorrectEmailOrPassword: "E-mail ou mot de passe invalide",
            captchaRequired: "Trop de tentatives échouées. Veuillez compléter la vérification de sécurité ci-dessous, puis réessayer.",
            captchaInvalid: "La vérification de sécurité a échoué ou a expiré. Veuillez la recommencer.",
            captchaMissing: "Veuillez compléter la vérification de sécurité avant de vous connecter.",
            logIn: "Se connecter",
            signInToYourAccount: "Connectez-vous à votre compte",
            signInWithMicrosoft: "Se connecter avec Microsoft",
            signUpWithMicrosoft: "S'inscrire avec Microsoft",
            msgReset: "Nous vous enverrons des instructions pour réinitialiser votre mot de passe après avoir saisi votre adresse électronique.",
            mailVerification: "Vérifiez votre boîte mail Nous avons envoyé un lien de réinitialisation.",
            newPassword: "Nouveau mot de passe",
            confirmNewPassword: "Confirmer le nouveau mot de passe",
            newPassWordIsRequired: "Le nouveau mot de passe est obligatoire",
            password: "Mot de passe",
            passwordsNotMatch: "Les mots de passe ne correspondent pas",
            passwordIsRequired: "Le mot de passe est obligatoire",
            passwordSuccessfully: "Mot de passe réinitialisé avec succès",
            professionalEmail: "Email invalide. Veuillez saisir une adresse email professionnelle (ex. : prenom@votreentreprise.com)",
            pleaseFollowTheInstructions: "Suivez les instructions",
            resetYourPassword: 'Réinitialiser votre mot de passe',
            reset: 'Réinitialiser',
            signUp: "S'inscrire",
            ssoRedirectTitle: "Votre organisation utilise l'authentification unique",
            ssoRedirectBody:
                "L'adresse {{email}} dépend du portail sécurisé de votre organisation. Aucun compte n'est créé ici.",
            ssoRedirectDestination: "Nous vous redirigeons vers",
            ssoRedirectMailSending: "Envoi du lien de connexion par e-mail…",
            ssoRedirectMailSent: "Lien de connexion envoyé à {{email}}",
            ssoRedirectMailFailed:
                "Le lien n'a pas pu être envoyé par e-mail, mais vous pouvez continuer dès maintenant.",
            ssoRedirectGoNow: "Continuer vers le portail",
            ssoRedirectUseAnotherEmail: "Utiliser une autre adresse",
            ssoRedirectCountdown_one: "Redirection automatique dans {{count}} seconde",
            ssoRedirectCountdown_other: "Redirection automatique dans {{count}} secondes",
            seamlessly: "Documentez vos processus en toute transparence et atteignez la conformité ISO 9001:2015 en toute confiance.",
            thisEmailHasBanned: "Cette adresse e-mail a été retirée de {{appName}}",
            userDoesNotExist: "L'utilisateur n'existe pas",
            resetLinkInvalidOrExpired:
                "Ce lien de réinitialisation est invalide ou expiré. Utilisez le lien du dernier e-mail reçu ou refaites une demande de mot de passe oublié.",
            verifyYourEmail: "Veuillez vérifier votre adresse e-mail",
            verifyYourEmailDetail: "Votre compte n'est pas encore vérifié. Consultez votre boîte mail ou renvoyez un nouveau lien de vérification à l'adresse indiquée.",
            resendVerificationLink: "Renvoyer le lien de vérification",
            resendVerificationSuccess: "Si un compte non vérifié existe pour cette adresse, un nouveau lien vient d'être envoyé.",
            resendVerificationError: "Impossible d'envoyer l'e-mail de vérification. Veuillez réessayer.",
            yourSessionHasExp: "Votre session a expiré ou vous êtes connecté sur un autre appareil.",
            referral: "Code de parrainage",
            signUpWithReferral: "S'inscrire avec un code de parrainage",
            authenticating: "Connexion en cours...",
            pleaseWait: "Veuillez patienter",
            brandHeadlineLead: "Votre infatigable",
            brandHeadlineAccent: "analyste de processus junior.",
            brandSubtitle: "Gère le recueil, les entretiens et la documentation pour que les experts seniors se concentrent strictement sur la stratégie et la mise en œuvre",
            brandFeature1Title: "Interagit avec votre équipe",
            brandFeature1Desc: "Entretiens IA adaptatifs et adaptés aux rôles dans toute votre organisation pour comprendre comment le travail est réalisé",
            brandFeature2Title: "Relie les points et montre son travail",
            brandFeature2Desc: "Rédige automatiquement des VSM, BPMN et cartographies de processus éditables et sourcées",
            brandFeature3Title: "Livre une analyse approfondie",
            brandFeature3Desc: "Signale les goulots d'étranglement, les délais de transfert et le Muda selon la méthodologie Lean Six Sigma",
            brandBuiltBy: "Conçu par des dirigeants issus de",
        },
        processView: {
            accessAdminPanel: "Accéder au panneau Admin",
            accessFolders: "Accéder aux dossiers",
            analyzeOptimize: "Analyser et optimiser",
            areYouSure: " Êtes-vous sûr de vouloir supprimer cet élément ?",
            brainstorm: " Transformez vos objectifs en actions concrètes",
            browseLibrary: "Accéder à la bibliothèque ",
            createAndOrganize: "Créer un dossier pour organiser vos processus",
            comingSoon: "Bientôt",
            new: "Nouveau",
            defaultFolder: "Dossier par Défaut",
            designFutureProcess: "Vibe Managing",
            discoverASISProcess: "Découvrir le processus actuel",
            exploreSavedAndSharedProcesses: " Retrouvez vos processus partagés et sauvegardés",
            exploreUseCases: " Explorez les cas d'usage",
            folder: "Dossier",
            folders: "Dossiers",
            folderNotFound: "Dossier non trouvé",
            generateDiagram: "Dessiner un workflow",
            getInspired: "S'inspirer d'exemples de processus populaires et percutants",
            harnessCollectiveIntelligence: "Activez l’intelligence collective de votre équipe",
            identifyGaps: "Identifiez les points d'amélioration et agissez",
            inviteTeammate: "Inviter des collègues",
            inviteTeammateDesc: "Activez l'intelligence collective de votre équipe",
            myProcess: 'Mes processus',
            myProcessesToolbar: 'Contrôles de la liste des processus',
            myProcessesSortNewest: 'Trier par date (plus récents)',
            myProcessesSortOldest: 'Trier par date (plus anciens)',
            myProcessesSortNewestShort: 'Récents',
            myProcessesSortOldestShort: 'Anciens',
            myProcessesFilterStatus: 'Statut',
            myProcessesFilterOwner: 'Propriétaire',
            myProcessesFilterType: 'Type',
            myProcessesFilterAll: 'Tous',
            myProcessesOwnerOther: 'Autres',
            myProcessesClearFilters: 'Effacer les filtres',
            myProcessesViewMode: 'Mode d’affichage',
            myProcessesViewGrid: 'Vue grille',
            myProcessesViewList: 'Vue liste',
            myProcessesNoFilterResults: 'Aucun processus ne correspond à ces filtres',
            navigateThroughOrganizedFoldersToFindStoredProcesses: "Naviguez à travers des dossiers organisés pour trouver les processus stockés",
            newProcess: 'Nouveau processus',
            newfolder: "Nouveau Dossier",
            needInspiration: "Besoin d'inspiration ? Explorez ces cas d'usage populaires",
            library: "Librairie",
            overseeUserRoles: "Gérez les rôles, accès et paramètres utilisateurs",
            popularUseCase: "Cas d'usage populaires",
            processNotFound: "Processus non trouvé",
            reportNotFound: "Aucun rapport trouvé",
            startJourneyPrompt: "Prêt à entamer votre parcours de transformation ?",
            turnTextIntoVisualProcessMapUsingAI: "Utilisez l’IA pour transformer un texte ou une image en cartographie visuelle claire",
            uncover: "Laissez l’IA guider l’entretien de découverte",
            viewAll: 'Voir tout',
            homeStatsMapped: "Processus cartographiés",
            homeStatsInterviews: "Entretiens réalisés",
            homeStatsTeam: "Membres d'équipe",
            homeStatsTimeSaved: "Temps total économisé",
            homeStatsSubMapped: "Total dans votre espace",
            homeStatsSubInterviews: "Sur vos processus",
            homeStatsSubTeam: "Espaces de travail",
            homeStatsSubTime: "vs cartographie manuelle dans votre compagnie",
            homeStartSomething: "Pour commencer",
            homeMapProcess: "Cartographier un processus",
            homeMapProcessDesc: "Interviewez les parties prenantes avec l'IA pour capturer comment le travail se fait réellement.",
            homeBuildDocument: "À partir d'un document",
            homeBuildDocumentDesc: "Transformez texte ou images en diagramme de processus structuré.",
            homeGetInsights: "Obtenir des insights",
            homeGetInsightsDesc: "Mettez en évidence les écarts, goulots et pistes d'amélioration.",
            homeVibeManaging: "Vibe managing",
            homeVibeManagingDesc: "Transformez les objectifs métier en actions concrètes.",
            homeCollectData: "Collecter des données",
            homeCollectDataDesc: "Menez une enquête guidée par l'IA pour enrichir une cartographie de processus ou recueillir des informations structurées auprès de votre équipe",
            homeAutomate: "Automatiser",
            homeAutomateDesc: "Rendez votre processus exécutable. Générez des applications, une logique de routage et des transferts de tâches à partir de tout workflow cartographié.",
            homeRecentProcesses: "Tâches récentes",
            homeTypeDataCollect: "Collecte de données",
            homeTypeProcessMap: "Cartographie de processus",
            homeTypeManual: "Canvas vierge",
            homeTypeAI: "Entretien IA",
            homeTypeHuman: "Import texte",
            homeTypeImage: "Import image",
            homeDetailManual: "Dessin manuel — sans entretien",
            homeDataCollectKind: "Réponses structurées",
            homeStatusNew: "Nouveau",
            homeStatusMapped: "Cartographié",
            homeStatusOngoing: "En cours",
            homeStatusCompleted: "Terminé",
            homeInterviewCount_one: "{{count}} entretien",
            homeInterviewCount_other: "{{count}} entretiens",
            homeGreetingMorning: "Bonjour",
            homeGreetingAfternoon: "Bon après-midi",
            homeGreetingEvening: "Bonsoir",
            homeGreetingFallback: "à vous",
            homeWelcomeSubtitle: "Reprenez là où vous vous êtes arrêté, ou commencez quelque chose de nouveau.",
            homeStatsTimeSavedShort: "Temps économisé",
            homeBuildDiagram: "Créer un diagramme",
            homeHeroTitle: "Transformez le travail réel en une cartographie claire",
            homeHeroDescription: "Interrogez votre équipe ou importez un fichier texte ou une image — chaque méthode mène au même diagramme modifiable. Choisissez votre méthode à l'étape suivante.",
            homeCreateDiagram: "Créer un diagramme",
            homeMethodsSummary: "Entretien · Import · Texte · Image",
            homeArtRequest: "Demande",
            homeArtRequestDesc: "Soumettez votre processus, idée ou tâche pour commencer.",
            homeArtReview: "Revue ?",
            homeArtReviewDesc: "Votre demande est examinée, commentée et validée.",
            homeArtApprove: "Approuver",
            homeArtApproveDesc: "Approuvé ! Votre processus avance.",
            homeThenReady: "Puis, lorsque vous êtes prêt",
            homeCreateEyebrow: "Créer un nouveau processus",
            homeCreateSubtitle: "Choisissez comment démarrer, puis renseignez les détails — sur un seul écran.",
            homeCreateDrawSubtitle: "Donnez un titre à votre diagramme et ouvrez un canvas vierge tout de suite.",
            homeStartingMethod: "Méthode de départ",
            homeMethodInterview: "Entretien",
            homeMethodThorough: "Approfondi",
            homeMethodUpload: "Importer un document",
            homeMethodUploadTypes: "Texte · image",
            homeMethodDraw: "Dessiner",
            homeMethodBlankCanvas: "Canvas vierge",
            homeMethodInterviewBlurb: "L'IA interroge votre équipe sur le travail réel et le cartographie.",
            homeMethodUploadBlurb: "Transformez un fichier texte ou une image en diagramme structuré.",
            homeMethodUploadTextBlurb: "Importez un PDF, TXT ou DOCX — Famla le structure en cartographie de processus.",
            homeMethodUploadImageBlurb: "Importez un PDF ou une capture d'écran — Famla le transforme en diagramme swimlane.",
            homeMethodDrawBlurb: "Partez d'un canvas vide et construisez librement votre diagramme.",
            homeOutputType: "Type de sortie",
            homeOutputStandard: "Standard",
            homeOutputBpmn: "BPMN",
            homeOutputStandardBlurb: "Cartographie swimlane classique",
            homeOutputBpmnBlurb: "Cartographie avec symboles BPMN.",
            homeDocumentType: "Type de document",
            homeProcessName: "Nom du processus",
            homeProcessNamePlaceholder: "Ex. Reporting financier",
            homeProcessPurpose: "Objectif du processus",
            homeProcessPurposePlaceholder: "Décrivez ce que ce processus accomplit et à qui il s'adresse",
            homeSelectIndustry: "Sélectionner un secteur",
            homeInterviewLanguage: "Langue de l'entretien",
            homeCreateInterview: "Créer l'entretien",
            homeCreateUpload: "Créer depuis le document",
            homeCreateUploadText: "Créer depuis un fichier texte",
            homeCreateUploadImage: "Créer depuis une image",
            homeCreateBlankDiagram: "Ouvrir le canvas vierge",
            homeCreateBlankDiagramError: "Impossible de créer le canvas vierge. Veuillez réessayer.",
            homeCreateIndustryLoadError: "Impossible de charger les secteurs. Veuillez réessayer.",
            libraryRecentProcesses: "Tâches récentes",
            libraryNewFolder: "Nouveau dossier",
            libraryRecentInsights: "Insights récents",
            libraryNoInsights: "Pas encore d'insights",
            libraryFolderProcessCount: "{{count}} processus",
            addProcessOwner: "Ajouter un co-propriétaire",
            addCollectionOwner: "Ajouter un co-propriétaire de collection",
            addCollectionOwnerHint:
                "Saisissez l’e-mail professionnel d’un utilisateur déjà enregistré et membre de votre compagnie.",
            addCollectionOwnerScenarios:
                "Seuls les membres de la compagnie sont acceptés. Si la personne n’appartient pas à la compagnie, l’ajout est refusé.",
            addProcessOwnerHint: "Saisissez l’e-mail professionnel d’un utilisateur déjà enregistré et membre de votre compagnie.",
            addProcessOwnerScenarios: "Seuls les membres de la compagnie sont acceptés. Si la personne n’appartient pas à la compagnie, l’ajout est refusé. Si elle a déjà un rôle sur ce processus (ex. collaborateur), l’opération est refusée tant que cette collaboration existe."
        },
        processInterview: {
            addCollaborators: "Ajouter des collaborateurs",
            attachFile: "Joindre un fichier",
            skipForNow: "Passer pour l'instant",
            skipContextAnswer: "Je passe l’ajout de documents pour l’instant.",
            contextFileAttachedNote: "J’ai joint un fichier pour le contexte : {{fileName}}.",
            contextMapsAttachedNote: "J’ai joint des cartographies pour le contexte : {{mapNames}}.",
            contextChoiceAria: "Contexte optionnel : fichier, cartographie ou passer",
            browse: 'Parcourir',
            cannotReplaceOwner: "Vous ne pouvez pas remplacer le propriétaire de l'entretien.",
            cannotReplaceWhenInterviewFinished: "Vous ne pouvez pas remplacer un participant lorsque l'entretien est terminé.",
            cannotDeleteMappedInterview: "La suppression lancera une régénération de la cartographie et consommera des crédits.",
            collaborators: "Contributeurs",
            contributor: "Contributeur",
            notInvited: "Non invité",
            confirmEditPermissionGrant: "Êtes-vous sûr de vouloir permettre à cet employé de modifier la cartographie ?",
            confirmEditPermissionRevoke: "Êtes-vous sûr de vouloir révoquer les droits d'édition de cet utilisateur ?",
            confirmDeleteAnalysisReport: "Êtes-vous sûr de vouloir supprimer définitivement ce rapport d'analyse ? Cette action est irréversible.",
            comment: "Commentaire",
            dropYourFileHere: "Glissez votre fichier ici, ou",
            diagramsList: "Liste des diagrammes",
            noDiagrams: "Aucun diagramme",
            noAnalyses: "Aucune analyse",
            disableEditMode: "Désactiver l'édition",
            deleteDiagramme: "Êtes-vous certain de vouloir supprimer définitivement ce diagramme ? Cette action est irréversible.",
            diagramDeletedSuccess: "Le diagramme a été supprimé avec succès.",
            diagramDeletedError: "La suppression du diagramme a échoué. Veuillez réessayer.",
            analysisDeletedSuccess: "Le rapport d'analyse a été supprimé avec succès.",
            analysisDeletedError: "La suppression du rapport d'analyse a échoué. Veuillez réessayer.",
            deleteInterviewQuestion: "Êtes-vous sûr de vouloir supprimer cet entretien ? Cette action est irréversible.",
            deleteOwnerInterviewQuestion: "Retirer l’entretien du process owner ? La personne reste propriétaire du processus ; seule l’interview est supprimée.",
            deleteMappingSourceTitle: "Suppression et régénération de la cartographie",
            deleteMappingSourceWarning: "L’input de cette personne a servi de source à la cartographie. La supprimer lancera une nouvelle génération et consommera des crédits (minimum {{credits}}).",
            deleteMappingSourceRoleWarning: "Au moins une personne de ce rôle a servi de source à la cartographie. Les retirer lancera une nouvelle génération et consommera des crédits (minimum {{credits}}).",
            deleteAndRegenerate: "Supprimer et régénérer",
            enableEditMode: "Activer l'édition",
            fileUploaded: "Fichier téléchargé avec succès.",
            grantEditPermission: "Accorder le droit d'édition",
            interviewNotFound: "Une erreur est survenue. Entretien introuvable.",
            mapReady: "Diagramme prêt dans 10 minutes",
            memberAdded: "Membre ajouté avec succès.",
            newProcess: "Nouveau processus",
            pendingInvitation: "Invitation en attente",
            pleaseEnsure: "Merci de maintenir la même orthographe pour les parties prenantes et clients dans toutes vos réponses.",
            processNotFound: "Une erreur est survenue. Processus introuvable.",
            processUpdateRestricted: "Vous n'êtes pas autorisé à modifier ce processus.",
            recentAnalyses: 'Analyses récentes',
            reminderMessage: "Un email de rappel sera envoyé au collaborateur invité.",
            reminderSent: "Email de rappel envoyé avec succès.",
            requestLimit: "Limite de requêtes atteinte. Passez à la version Premium pour continuer sans interruption.",
            oneActionAtTime: "Veuillez effectuer une seule action à la fois : collez la transcription ou importez un fichier.",
            pasteTranscriptInstruction: "Ajoutez un fichier... Complétez si besoin, puis cliquez sur Envoyer",
            pendingInvitation: "Invitation en attente - L'utilisateur n'a pas encore créé son compte",
            reply1: "Fin de l'entretien, merci pour votre contribution.",
            reply2: "Fin de l'entretien, merci pour votre contribution. Nous contacterons l'équipe et reviendrons vers vous ultérieurement.",
            reply3: "J'ai terminé les entretiens, cliquez sur la carte de génération pour voir le résultat.",
            reply4: "Pouvez-vous dresser la liste des collaborateurs manquants ?",
            reply5: "Souhaitez-vous ajouter quelque chose d'autre ou une information supplémentaire que vous jugez utile de nous communiquer ?",
            recentProcesses: "Processus récents",
            sucessDelete: "L'entretien a été supprimé avec succès.",
            // eslint-disable-next-line no-template-curly-in-string
            s1: "Votre carte de processus sera prête dans 10 minutes!-En tant que responsable de processus, vous avez économisé {{time}} minutes d'entretien !",
            // eslint-disable-next-line no-template-curly-in-string
            s2: "Votre carte de processus sera prête dans 10 minutes!-{{time}} minutes d'entretien récupérées ! {{appName}} donne du pouvoir aux responsables de processus comme vous.",
            // eslint-disable-next-line no-template-curly-in-string
            s3: "Votre carte de processus sera prête dans 10 minutes!-{{time}} minutes gagnées sur les entretiens. Responsables de processus, {{appName}} rationalise votre travail.",
            tip: "Astuce: Documentez la réalité, pas l'idéal, pour révéler le véritable potentiel d'amélioration .",
            interviewRailNotifications: {
                insight: {
                    label: "Insight",
                    text: "Chevauchement de rôles détecté entre Fournisseur et Consommateur — peut indiquer un écart de transfert.",
                },
                update: {
                    label: "Mise à jour plateforme",
                    text: "Analyse & Optimisation est maintenant disponible. Lancez votre première analyse d'écart sur ce processus.",
                },
                event: {
                    label: "Webinaire",
                    text: "Lean Six Sigma & IA — 10 avril à 14h. Inscrivez-vous pour réserver votre place.",
                },
                ad: {
                    label: "Upgrade",
                    text: "Débloquez les versions illimitées de diagrammes avec le plan Business.",
                },
            },
            validFille: "Fichier invalide : max 10 Mo.",
            validFilleAi: "Fichier invalide : max 5 Mo.",
            validSize: "PDF,JPG,JPEG,PNG,GIF,WEBP (max.5Mo)",
            yourResponse: "Ajoutez un fichier... Complétez si besoin, puis cliquez sur Envoyer",
            responseSimple: "Réponse...",
            youCannotDelete: "Vous ne pouvez pas supprimer cet entretien car il est déjà terminé.",
            forceGenerate: "Forcer la génération de la carto",
            forceGenerateTooltip: "Obtenez un aperçu anticipé de vos cartographies. Générez maintenant et poursuivez les entretiens à tout moment.",
            forceGenerateConfirmTitle: "Forcer la génération de la cartographie",
            forceGenerateConfirmMessage: "Êtes-vous sûr de vouloir forcer la génération de la cartographie ? Les entretiens en cours resteront accessibles pour les participants qui souhaitent les terminer.",
            forceGenerateSuccess: "La génération de la cartographie a été déclenchée avec succès.",
            forceGenerateCooldown: "Veuillez patienter avant de forcer une nouvelle génération.",
            forceGenerateCooldownTimer: "Disponible dans {{minutes}}m {{seconds}}s",
            forceGenerateSidebarMapPending: "Génération de la carte…",
            diagramsLoading: "Chargement des cartographies…",
            forceGenerateRequestPending: "Envoi en cours…",
            forceGenerateNotOwner: "Seul le propriétaire, le co-propriétaire ou un admin peut forcer la génération.",
            forceGenerateAlreadyCompleted: "Tous les entretiens sont déjà terminés. La cartographie est générée automatiquement.",

            voiceTooltipLaunch: "Lancer le mode vocal",
            voiceButtonLaunch: "Lancer le mode vocal",
            voiceConversationStart: "Lancer le mode vocal",
            voiceConversationStop: "Arrêter le mode vocal",
            voiceConnecting: "Connexion…",
            voiceRealtimeLabel: "Parlez avec l'intervieweur IA",
            voiceRealtimeHint: 'Dites « Bonjour » pour commencer votre entretien.',
            voiceLocksInputPlaceholder: 'Pour saisir au clavier, cliquez sur « Arrêter le mode vocal ».',
            voiceLoginRequired: "Connectez-vous pour utiliser le mode vocal.",
            voiceClearDraftFirst: "Envoyez ou effacez votre message avant de démarrer le mode vocal.",

            // Actions rapides (rail droit de l'entretien)
            quickActionsTitle: "Actions rapides",
            startNewDiscovery: "Nouvel entretien de découverte",
            openProcessLibrary: "Ouvrir bibliothèque de processus",
            exportTranscript: "Exporter Transcript",
            share: "Partager",

            // Progress steps
            scopeSet: "Périmètre défini",
            progress: "Progrès",
            notificationsTitle: "Messages et notifications",
            noNotifications: "Aucun message pour l'instant.",

            // Progress section translations
            stakeholdersInvited: "Parties prenantes invitées",
            interviewsDone: "Entretiens terminés",
            mapsAvailable: "Cartographies disponibles",
            diagramsGenerated: "générés",
            mapsGeneratingProgress: "Génération en cours ({{remaining}}/{{total}} restantes)…",
            mapsGenerationTimedOut: "La génération prend plus de temps que prévu. Les cartographies apparaîtront dès qu'elles seront prêtes, ou relancez via Forcer la génération.",

            // New interview button
            newInterview: "Nouvel entretien",

            // Add role functionality
            addRole: "Ajouter un rôle",
            addContributor: "Ajouter un contributeur",
            createRole: "Ajouter un rôle",
            createRolePlaceholder: "Nom du nouveau rôle",
            renameRole: "Renommer le rôle",
            currentRole: "Rôle actuel",
            changeRole: "Changer de rôle",
            dragPerson: "Glisser vers un autre rôle",
            dropHere: "Déposer ici",
            dragRole: "Glisser pour réordonner",
            deleteRoleTitle: "Supprimer le rôle",
            deleteRoleConfirm: "Que faire des personnes assignées à « {{role}} » ?",
            deleteEmptyRoleConfirm: "Supprimer le rôle « {{role}} » ? Personne n’y est plus assigné.",
            reassignTo: "Réassigner vers un autre rôle",
            reassignTargetRequired: "Veuillez choisir un rôle cible.",
            removeAssignments: "Retirer toutes les personnes de ce rôle",
            duplicateRoleName: "Ce rôle existe déjà.",
            roleUpdateFailed: "Impossible de mettre à jour le rôle.",
            moveFailed: "Impossible de déplacer le contributeur.",
            emptyRole: "Non invité",

            // Upgrade hint
            upgradeHint: "Débloquez des versions de diagrammes illimitées avec le plan Business.",
            businessPlanHint: "Débloquez des versions de diagrammes illimitées avec le plan Business.",
        },
        modal: {
            accessDenied: {
                title: "Accès Restreint",
                message: "Vous n'avez pas l'autorisation de consulter les réponses des autres collaborateurs.",
                collaboratorInfo: "Vous tentez d'accéder aux réponses de : ",
                whyTitle: "Pourquoi cette restriction ?",
                reason1: "Pour protéger la confidentialité des réponses de chaque participant",
                reason2: "Seul le Process Owner peut consulter toutes les réponses",
                reason3: "Vous pouvez uniquement voir vos propres réponses",
                understood: "J'ai compris"
            },
            insufficientCredits: {
                title: "Crédits insuffisants",
                message: "Cette action nécessite des crédits supplémentaires.",
                creditsRequired: "Crédits requis",
                creditsAvailable: "Crédits disponibles",
                deficit: "Déficit",
                suggestion: "Choisissez un plan payant pour débloquer cette fonctionnalité :",
                choosePlan: "Choisir un plan",
                contactOwner: "Contactez l'administrateur de votre compagnie à l'adresse suivante pour mettre à niveau le plan et obtenir plus de crédits.",
                ownerEmail: "Administrateur",
                contactOwnerButton: "Contacter l'administrateur",
            },
            planSelection: {
                title: "Choisir le plan",
                planDetails: "Détails du plan",
                plan: "Plan",
                price: "Prix",
                credits: "Crédits",
                subscribe: "Souscrire",
                contactSales: "Contacter les ventes",
                stripeInfo: "L'intégration Stripe est en cours. Vous serez redirigé vers la page de paiement sécurisée.",
                stripeComingSoon: "Intégration Stripe en cours. Contactez-nous pour souscrire.",
                paymentReady: "Vous serez redirigé vers la page de paiement sécurisée.",
                contactUs: "Pour souscrire à ce plan, veuillez nous contacter via notre formulaire de contact",
                contactUsInfo: "Pour souscrire, vous serez redirigé vers notre formulaire de contact",
                paymentError: "Erreur lors de l'initiation du paiement. Veuillez réessayer.",
                essential: {
                    description: "Achat ponctuel. Pas d'expiration, top-up disponible à tout moment."
                },
                plus: {
                    description: "Souscription mensuelle. Roll-over {{percentage}}% des crédits non utilisés (max {{max}} crédits)."
                },
                enterprise: {
                    description: "Forfait personnalisé avec crédits sur mesure, support dédié et SLA premium. Contactez-nous pour un devis.",
                    contact: "Contactez-nous via notre formulaire de contact ({{supportEmail}}) pour un devis personnalisé"
                }
            },
            creditHistory: {
                title: "Historique des crédits",
                filter: "Filtrer par type",
                filterAll: "Tous",
                filterDeduct: "Déductions",
                filterAdd: "Ajouts",
                filterTopup: "Recharges",
                filterGift: "Cadeaux",
                filterRefund: "Remboursements",
                filterRollover: "Reports",
                filterAdjust: "Ajustements",
                loading: "Chargement...",
                noTransactions: "Aucune transaction trouvée",
                credits: "crédits",
                pageInfo: "Page {{current}} sur {{total}}",
                table: {
                    date: "Date",
                    type: "Type",
                    amount: "Montant",
                    balance: "Solde"
                },
                type: {
                    deduct: "Déduction",
                    add: "Ajout",
                    topup: "Recharge",
                    gift: "Cadeau",
                    refund: "Remboursement",
                    rollover: "Report de crédits",
                    adjust: "Ajustement"
                },
                action: {
                    generation: "Génération de processus",
                    analysis: "Analyse de processus",
                    mappingUnlock: "Déverrouillage de cartographie"
                }
            },
            subscription: {
                title: "Gérer ma subscription",
                loading: "Chargement des détails...",
                details: "Détails de la subscription",
                statusLabel: "Statut",
                monthlyAmount: "Montant mensuel",
                nextBillingDate: "Prochain prélèvement",
                cancelScheduledLabel: "Annulation programmée",
                endOfPeriod: "Fin de période",
                cancelScheduled: "Annulation programmée",
                cancelScheduledDescription: "Votre subscription sera annulée le",
                keepAccess: "Vous gardez l'accès aux fonctionnalités PLUS jusqu'à cette date.",
                reactivate: "Réactiver",
                processing: "Traitement...",
                cancelButton: "Annuler la subscription",
                openPortal: "Gérer via Stripe Portal",
                opening: "Ouverture...",
                confirmCancel: "Confirmer l'annulation",
                confirmCancelDescription: "Êtes-vous sûr de vouloir annuler votre subscription PLUS ?",
                cancelImmediately: "Annuler immédiatement",
                cancelAtPeriodEnd: "Annuler à la fin de la période",
                immediateInfo: "L'annulation immédiate réinitialisera vos crédits à 0 et vous perdrez accès aux fonctionnalités PLUS.",
                gracefulInfo: "L'annulation à la fin de la période vous permet de continuer à utiliser vos crédits et fonctionnalités PLUS jusqu'à la fin du cycle de facturation.",
                confirm: "Confirmer l'annulation",
                cancel: "Annuler",
                cancelSuccess: "Votre subscription a été annulée avec succès",
                reactivateSuccess: "Votre subscription a été réactivée avec succès",
                error: "Une erreur est survenue. Veuillez réessayer ou contacter le support."
            },
            paymentMethods: {
                title: "Méthodes de paiement",
                loading: "Chargement des méthodes de paiement...",
                empty: "Aucune méthode de paiement enregistrée",
                default: "Par défaut",
                expires: "Expire",
                info: "Gérez vos méthodes de paiement via le portail Stripe pour ajouter, modifier ou supprimer une carte.",
                openPortal: "Ouvrir le portail Stripe",
                emptyDescription: "Ajoutez une méthode de paiement via le portail Stripe pour gérer vos paiements."
            },
            invoices: {
                title: "Mes factures",
                loading: "Chargement des factures...",
                noInvoices: "Aucune facture trouvée",
                empty: "Aucune facture disponible",
                emptyDescription: "Vos factures apparaîtront ici après vos premiers paiements.",
                date: "Date",
                amount: "Montant",
                status: "Statut",
                download: "Télécharger PDF",
                statusPaid: "Payée",
                statusOpen: "En attente",
                statusDraft: "Brouillon",
                statusVoid: "Annulée",
                statusUncollectible: "Impayée"
            },
            planChange: {
                title: "Changer de plan",
                loading: "Chargement des plans disponibles...",
                currentPlan: "Plan actuel",
                recommendation: "Recommandations",
                availablePlans: "Plans disponibles",
                downgradeWarning: "Attention - Procédure en 2 étapes",
                plusToEssentialSteps: "Pour passer de PLUS à ESSENTIAL, vous devez d'abord annuler votre subscription PLUS, puis activer ESSENTIAL.",
                upgradeInfo: "Vous serez redirigé vers le paiement sécurisé. Le changement sera effectif immédiatement après paiement.",
                error: "Erreur lors du chargement des plans disponibles",
                processing: "Traitement...",
                confirm: "Confirmer le changement"
            },
            topUp: {
                title: "Recharger des crédits",
                currentBalance: "Solde actuel",
                credits: "Crédits disponibles",
                packageDetails: "Détails du rechargement",
                package: "Pack de crédits",
                price: "Prix",
                newTotal: "Nouveau solde",
                howItWorks: "Comment ça fonctionne ?",
                info1: "Les crédits sont ajoutés immédiatement à votre solde",
                info2: "Pas d'expiration, utilisez-les quand vous voulez",
                info3: "Vous restez sur votre plan ESSENTIAL actuel",
                info4: "Paiement sécurisé par Stripe",
                info4Microsoft: "Achat et facturation via Azure Marketplace (compte Microsoft)",
                benefits: "Avec ces crédits, vous pourrez",
                benefit1: "nouveaux processus à générer",
                benefit2: "tokens d'analyse de documents",
                benefit3: "Accès à toutes les fonctionnalités ESSENTIAL",
                purchase: "Acheter pour",
                purchaseViaAzure: "Acheter via Azure Marketplace"
            }
        },
        processByGroupView: {
            approvalName: "Approbateur",
            approvalDate: "Date approbation",
            dateFormat: "La date doit être au format YYYY-MM-DD HH:MM:SS",
            diagramLink: "Lien du diagramme",
            formatDate: "AAAA-MM-JJ HH:mm:ss",
            interviewTime: "Temps d'interview gagné",
            lastModifiedDate: "Dernière modification",
            noProcess: "Aucun processus",
            nexRevisionDate: "Prochaine révision",
            ownerName: "Propriétaire",
            processName: "Nom du processus",
            processMetrics: "KPIs processus",
            revisionTriggers: "Motifs révision",
            requestChange: "Demande de modification"

        },

        legalDocs: {
            contact: {
                eitherFill: "Vous pouvez remplir le formulaire ou utiliser les coordonnées ci-dessous.",
                gettingInTouch: "La prise de contact est facile!",
                sendMeCopy: "Envoyer une copie",
                success: "Message envoyé avec succès!",
                error: "Une erreur s'est produite lors de l'envoi du message. Veuillez réessayer.",
                invalidEmail: "Veuillez entrer une adresse e-mail valide.",
            },

            faq: {
                contactUsPage: ' page Contactez-nous',
                p1: "Pensez à vos processus comme à l'ADN de votre organisation - ils sont le schéma directeur de la façon dont les choses sont faites ! {{appName}} a été créé pour aider les organisations de toutes tailles, industries et sites à comprendre, documenter et rationaliser ces flux de travail essentiels. Alors, qu'est-ce qui fait de {{appName}} l'outil idéal pour vous ? Il s'agit de simplicité, de rapidité et d'un puissant moteur d'amélioration de l'IA qui vous aide à travailler plus intelligemment, et non plus difficilement.",
                p2: "Cette première version se concentre sur les diagrammes transversaux (swimlane). Ces diagrammes sont parfaits pour visualiser le flux de travail entre différentes équipes ou départements. Nous ajouterons bientôt d'autres types de diagrammes !",
                p3: "Oui ! Nous prenons en charge les notations communes telles que BPMN (Business Process Model and Notation) afin de garantir la cohérence et la facilité de compréhension.",
                p4: "Bien sûr. Exportez vos cartes de processus sous forme d'images (PNG, JPEG) ou de fichiers PDF - parfaits pour les rapports, les présentations ou pour obtenir un retour d'information. Vous pouvez également inviter des personnes à visualiser les cartes terminées directement dans l'outil pour une collaboration rapide.",
                p5: "Absolument ! Nous avons conçu cet outil en pensant au travail d'équipe. Invitez facilement les membres de votre équipe à collaborer sur des cartes en temps réel, afin de faire de l'amélioration des processus un effort partagé.",
                p6: "Pas encore, mais c'est pour bientôt ! Nous savons à quel point il est important de tout organiser, c'est pourquoi nous travaillons sur la possibilité de joindre des fichiers, des liens, des notes, etc. directement dans vos cartes.",
                p7: "Préparez-vous à la magie des processus ! Notre moteur d'IA analyse vos cartes en utilisant les principes Lean Six Sigma pour identifier les domaines dans lesquels vous pouvez rationaliser et améliorer vos processus.",
                p8: "Définitivement. Nous prenons la sécurité des données au sérieux. Notre plateforme est hébergée sur Google Cloud, ce qui vous garantit une sécurité optimale grâce au cryptage et à toutes les mesures de protection les plus récentes.",
                p9: "Après votre inscription, un membre de notre équipe vous contactera pour discuter de vos besoins et de l'abonnement qui vous convient le mieux. En attendant, plongez dans l'outil, explorez-le et découvrez la puissance de {{appName}} de première main !",
                p10: "Notre équipe d'assistance est là pour vous ! N'hésitez pas à nous contacter à tout moment via notre ",
                p11: "Nous travaillons constamment à l'amélioration de {{appName}} et nous vous invitons à nous faire part des fonctionnalités que vous aimeriez voir apparaître.",
                t1: "{{appName}} est-elle la solution idéale pour mon entreprise ? ",
                t2: "Quels types de diagrammes de processus puis-je construire avec cet outil ?",
                t3: "Cet outil est-il compatible avec les normes de cartographie des processus que je connais déjà ?",
                t4: "Puis-je facilement partager mes cartes terminées avec d'autres personnes ?",
                t5: "Mon équipe et moi-même pouvons-nous travailler ensemble sur une carte de processus ? ",
                t6: "Puis-je connecter d'autres informations à mes cartes de processus ?",
                t7: "Comment cet outil peut-il m'aider à améliorer mes processus ? ",
                t8: "Les données de ma carte de processus sont-elles sécurisées ?",
                t9: "Proposez-vous un abonnement gratuit ou une période d'essai ?",
                t10: "Comment puis-je obtenir de l'aide si j'en ai besoin ?",
            },

            privacyPolicy: {
                title: "Politique de Confidentialité",
                subtitle: "Nous nous engageons à protéger votre vie privée. Cette politique explique comment nous collectons, utilisons et protégeons vos informations.",

                introduction: {
                    title: "Introduction",
                    p1: "{{appName}} (« nous », « notre », « nos » ou « Société ») exploite la plateforme {{appName}}. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations.",
                    p2: "Cette politique doit être lue en conjonction avec notre politique relative aux cookies et nos conditions de service.",
                    p3: "En accédant et en utilisant {{appName}}, vous reconnaissez avoir lu, compris et accepté d'être lié par tous les termes de cette politique de confidentialité. Si vous n'acceptez pas nos politiques et pratiques, veuillez ne pas utiliser nos services."
                },

                informationWeCollect: {
                    title: "Informations que Nous Collectons",

                    personalInfo: {
                        title: "Informations Personnelles que Vous Fournissez",
                        description: "Nous collectons les informations que vous nous fournissez directement, notamment :",
                        item1: "Détails d'inscription au compte (nom, email, organisation)",
                        item2: "Informations de paiement à des fins de facturation",
                        item3: "Contenu généré par l'utilisateur et données de processus",
                        item4: "Commentaires, demandes et demandes de support"
                    },

                    automaticInfo: {
                        title: "Informations Collectées Automatiquement",
                        description: "Lorsque vous utilisez {{appName}}, nous collectons automatiquement :",
                        item1: "Adresse IP et informations du navigateur/appareil",
                        item2: "Statistiques d'utilisation et modèles d'interaction",
                        item3: "Cookies et technologies de suivi similaires",
                        item4: "Fichiers journaux, horodatages et événements d'authentification"
                    },

                    thirdPartyInfo: {
                        title: "Informations de Tiers",
                        description: "Nous pouvons recevoir des informations via :",
                        item1: "Fournisseurs d'identité SSO",
                        item2: "Partenaires d'intégration",
                        item3: "Sources publiquement disponibles"
                    }
                },

                howWeUseYourInfo: {
                    title: "Comment Nous Utilisons Vos Informations",
                    description: "Nous utilisons les informations collectées pour :",
                    item1: "Fournir, maintenir et améliorer nos services",
                    item2: "Personnaliser votre expérience et fournir du contenu personnalisé",
                    item3: "Traiter les transactions et envoyer des informations de facturation",
                    item4: "Communiquer avec vous sur les mises à jour, modifications et support",
                    item5: "Effectuer des analyses et recherches pour optimiser notre plateforme",
                    item6: "Détecter et prévenir la fraude, l'abus et les incidents de sécurité",
                    item7: "Se conformer aux obligations légales et faire respecter nos accords"
                },

                dataSecurity: {
                    title: "Sécurité des Données",
                    description: "Nous mettons en œuvre des mesures de sécurité complètes pour protéger vos informations :",
                    item1: "Chiffrement de bout en bout en transit et au repos",
                    item2: "Clés de chiffrement gérées par le client disponibles pour les configurations dédiées",
                    item3: "Audits de sécurité réguliers et tests de pénétration",
                    item4: "Programme de sécurité aligné SOC 2",
                    item5: "Contrôles d'accès restreints et permissions basées sur les rôles",
                    item6: "Infrastructure cloud sécurisée avec redondance et sauvegardes"
                },

                yourRights: {
                    title: "Vos Droits et Choix",
                    description: "Vous disposez des droits suivants concernant vos informations personnelles :",
                    item1: "Accéder à vos données personnelles et demander une copie",
                    item2: "Corriger les informations inexactes ou incomplètes",
                    item3: "Supprimer votre compte et les données associées",
                    item4: "Vous désabonner des communications marketing",
                    item5: "Demander la portabilité des données dans un format structuré",
                    item6: "Retirer votre consentement à tout moment"
                },

                dataRetention: {
                    title: "Conservation des Données",
                    description: "Nous conservons vos informations personnelles aussi longtemps que nécessaire pour fournir nos services et réaliser les objectifs décrits dans cette politique. Vous pouvez demander la suppression de vos données à tout moment, sous réserve des exigences légales de conservation. Certaines informations peuvent être conservées sous forme anonymisée à des fins d'analyse et de conformité."
                },

                intellectualProperty: {
                    title: "Protection de la Propriété Intellectuelle",
                    description: "Toutes les données d'entrée et de sortie fournies via {{appName}} restent exclusivement les vôtres. Votre propriété intellectuelle n'est jamais utilisée pour entraîner un modèle de langage de grande taille ou partagée avec des tiers à des fins d'entraînement IA. Nous maintenons des politiques strictes garantissant que vos informations propriétaires et avantages concurrentiels restent confidentiels."
                },

                thirdPartyServices: {
                    title: "Services de Tiers",
                    p1: "Nous pouvons utiliser des tiers pour l'hébergement, l'analyse, l'authentification et des fonctions similaires.",
                    p2: "Ils ne peuvent accéder qu'aux données nécessaires pour remplir leur rôle et sont liés par des obligations de confidentialité et de sécurité."
                },

                cookiesAndTracking: {
                    title: "Cookies et Suivi",
                    p1: "{{appName}} utilise des cookies et des technologies similaires pour l'authentification, la performance, l'analyse, la personnalisation et la sécurité.",
                    p2: "Pour plus de détails, veuillez consulter notre politique relative aux cookies."
                },

                contact: {
                    description: "Si vous avez des questions concernant cette politique de confidentialité ou souhaitez exercer vos droits, veuillez nous contacter à :",
                    teamName: "Équipe Confidentialité {{appName}}",
                    email: "Email : {{supportEmail}}",
                    address: "Adresse : 77 Lower Camden Street, D02 XE80, Dublin, Irlande"
                },

                lastUpdated: "Dernière mise à jour : Novembre 2025"
            },
            termsOfService: {
                title: "Conditions d'utilisation",
                subtitle: "Veuillez lire attentivement ces conditions avant d'utiliser les services {{appName}}.",

                introduction: {
                    title: "Conditions d'utilisation",
                    p1: "Bienvenue chez {{appName}} (« {{appName}} », « nous », « notre » ou « nos »). Ces Conditions d'utilisation (« Conditions ») régissent votre accès et votre utilisation de {{appName}}, y compris notre site web, notre logiciel et tous les services connexes (collectivement, le « Service »). En utilisant le Service, vous acceptez d'être lié par ces Conditions.",
                    p2: "Votre utilisation du Service est également régie par notre Politique de Confidentialité et de Sécurité et notre Politique des Cookies.",
                    p3: "Si vous n'acceptez pas ces Conditions, veuillez ne pas utiliser le Service. Nous nous réservons le droit de modifier ces Conditions à tout moment. Votre utilisation continue de {{appName}} suite à de telles modifications constitue votre acceptation des Conditions mises à jour."
                },

                accountRegistration: {
                    title: "Inscription de compte",
                    p1: "Vous devez vous inscrire pour un compte et fournir des informations exactes. Vous êtes responsable du maintien de la confidentialité de vos identifiants de compte et de toutes les activités sous votre compte.",
                    p2: "Vous acceptez de nous notifier immédiatement de toute utilisation non autorisée."
                },

                licenseGrant: {
                    title: "Octroi de licence",
                    description: "Sous réserve de votre conformité à ces Conditions, {{appName}} vous accorde une licence limitée, non transférable, non exclusive pour accéder et utiliser le Service à des fins commerciales internes. Vous acceptez de ne pas :",
                    item1: "Modifier, copier ou créer des œuvres dérivées de nos services",
                    item2: "Effectuer de l'ingénierie inverse, décompiler ou tenter d'extraire le code source",
                    item3: "Supprimer ou modifier les mentions de droits d'auteur ou les marques propriétaires",
                    item4: "Louer, céder ou revendre l'accès à {{appName}}",
                    item5: "Utiliser le service pour l'analyse concurrentielle ou l'étalonnage",
                    item6: "Transmettre des virus, malwares ou codes malveillants",
                    item7: "Télécharger du contenu illégal ou abusif"
                },

                userResponsibilities: {
                    title: "Responsabilités de l'utilisateur",
                    description: "En tant qu'utilisateur de {{appName}}, vous êtes responsable de :",
                    item1: "Maintenir la sécurité de votre compte",
                    item2: "Respecter les lois applicables",
                    item3: "Ne pas violer les droits de propriété intellectuelle de tiers",
                    item4: "Ne pas vous engager dans un comportement illégal, menaçant ou nuisible",
                    item5: "Nous notifier immédiatement de tout accès non autorisé"
                },

                acceptableUse: {
                    title: "Politique d'utilisation acceptable",
                    description: "Vous acceptez de ne pas utiliser {{appName}} pour :",
                    item1: "Des activités illégales ou la violation de toute loi applicable",
                    item2: "Le harcèlement, la discrimination ou la diffamation",
                    item3: "L'accès non autorisé aux systèmes ou données",
                    item4: "La distribution de malwares ou de codes malveillants",
                    item5: "Le spamming ou les activités de phishing",
                    item6: "La violation des droits de propriété intellectuelle"
                },

                intellectualProperty: {
                    title: "Droits de propriété intellectuelle",
                    ourIP: {
                        title: "Notre propriété intellectuelle",
                        description: "Tout le contenu, les fonctionnalités et la conception de {{appName}} sont la propriété de {{appName}} ou de nos concédants de licence. Cela inclut le texte, les graphiques, les logos, le code et le logiciel. La reproduction ou l'utilisation non autorisée est interdite."
                    },
                    yourContent: {
                        title: "Votre contenu",
                        description: "Toutes les données d'entrée et de sortie que vous fournissez via {{appName}} restent exclusivement les vôtres. Vous conservez tous les droits sur vos informations propriétaires. Nous n'utilisons pas votre contenu pour entraîner des modèles d'IA ou à toute autre fin que la fourniture du service que vous avez demandé."
                    }
                },

                publicityRights: {
                    title: "Droits de publicité",
                    p1: "Sauf si vous nous notifiez par écrit que vous n'accordez pas la permission, vous accordez à {{appName}} le droit limité d'utiliser le nom et le logo de votre organisation (« Marques Client ») pour vous identifier comme client {{appName}} sur notre site web, présentations, propositions, pitch decks et matériaux similaires.",
                    p2: "{{appName}} ne divulguera pas d'informations confidentielles et utilisera les Marques Client uniquement à des fins d'identification.",
                    p3: "Vous pouvez révoquer cette permission à tout moment en nous notifiant par écrit."
                },

                disclaimers: {
                    title: "Exclusions de garantie",
                    p1: "{{appName}} est fourni sur une base « tel quel » et « tel que disponible ».",
                    p2: "{{appName}} ne garantit pas un fonctionnement ininterrompu, une performance sans erreur, ou l'adéquation à un usage particulier."
                },

                limitationOfLiability: {
                    title: "Limitation de responsabilité",
                    p1: "Dans toute la mesure permise par la loi, {{appName}} ne sera pas responsable des dommages indirects, accessoires, spéciaux ou consécutifs découlant de votre utilisation ou de votre incapacité à utiliser nos services, y compris mais sans s'y limiter la perte de profits, de données ou d'interruption d'activité, même si nous avons été informés de tels dommages.",
                    p2: "Notre responsabilité totale envers vous ne dépassera pas les frais que vous nous avez payés dans les douze mois précédant la réclamation."
                },

                indemnification: {
                    title: "Indemnisation",
                    description: "Vous acceptez d'indemniser, défendre et dégager de toute responsabilité {{appName}} et nos dirigeants, directeurs, employés et agents de toute réclamation, dommage ou dépense (y compris les frais juridiques) découlant de votre violation de ces Conditions, votre utilisation de {{appName}}, ou votre violation de toute loi applicable."
                },

                termination: {
                    title: "Résiliation",
                    description: "Nous pouvons résilier ou suspendre votre compte et l'accès à {{appName}} immédiatement et sans préavis pour :",
                    item1: "Violation de ces Conditions",
                    item2: "Activité illégale ou mauvaise utilisation du service",
                    item3: "Non-paiement des frais applicables",
                    item4: "Violation de notre Politique d'utilisation acceptable",
                    userTermination: "Vous pouvez résilier votre compte à tout moment en contactant notre équipe de support."
                },

                governingLaw: {
                    title: "Droit applicable",
                    description: "Ces Conditions sont régies et interprétées conformément aux lois de la République d'Irlande, sans égard à ses dispositions de conflit de lois. Toute action légale ou procédure découlant de ces Conditions doit être intentée exclusivement devant les tribunaux situés en République d'Irlande."
                },

                contact: {
                    title: "Informations de contact",
                    description: "Pour des questions concernant ces Conditions d'utilisation, veuillez nous contacter :",
                    teamName: "Équipe juridique {{appName}}",
                    email: "E-mail : {{supportEmail}}",
                    address: "Adresse : 77 Lower Camden Street, D02 XE80, Dublin, Irlande"
                },

                lastUpdated: "Dernière mise à jour : Novembre 2025"
            },


        },
        adminOnboarding: {
            userFallback: "vous",
            progress: "Étape {{step}} sur 2",
            skip: "Passer pour l'instant",
            welcomeTitle: "Bienvenue sur Famla, {{name}}",
            welcomeDescription: "Famla vous aide à comprendre clairement comment le travail est réalisé : cartographiez un processus, collectez les données associées ou lancez un questionnaire intelligent. Choisissez votre objectif principal et nous préparerons votre espace en conséquence.",
            setup: "Configurer mon espace",
            duration: "Environ 30 secondes",
            goalTitle: "Que voulez-vous faire en premier ?",
            goalSubtitle: "Choisissez votre objectif principal — vous pourrez tout faire ensuite.",
            new: "NOUVEAU",
            recommended: "RECOMMANDÉ",
            continue: "Continuer",
            readyDescription: "Votre espace est configuré pour cet objectif. Voici exactement où nous vous conduirons ensuite.",
            yourGoal: "Votre objectif",
            goals: {
                draw: {
                    title: "Dessiner un diagramme",
                    description: "Partez d'un canvas vierge, puis glissez, déposez et reliez vous-même les formes.",
                    readyTitle: "Votre canvas vierge est prêt",
                    readyHead: "Nous ouvrirons un canvas de dessin vierge",
                    readyDescription: "Saisissez un titre et nous ouvrirons immédiatement un canvas vierge.",
                    cta: "Ouvrir le canvas"
                },
                map: {
                    title: "Cartographier un processus",
                    description: "Laissez l'IA interroger votre équipe ou transformer un document existant en diagramme structuré.",
                    readyTitle: "Cartographions votre premier processus",
                    readyHead: "Nous ouvrirons l'écran Créer un diagramme",
                    readyDescription: "Choisissez un entretien IA ou transformez un texte ou une image en diagramme structuré.",
                    cta: "Créer un diagramme"
                },
                survey: {
                    title: "Lancer un questionnaire intelligent",
                    description: "Lancez un questionnaire piloté par l'IA pour recueillir des réponses structurées.",
                    readyTitle: "Configurons votre questionnaire",
                    readyHead: "Nous ouvrirons l'écran de création d'un questionnaire",
                    readyDescription: "Concevez un questionnaire IA qui recueille des réponses structurées et complète vos cartographies.",
                    cta: "Créer un questionnaire"
                }
            }
        },
        referral: {
            title: "Comment avez-vous entendu parler de nous ?",
            optional: "Optionnel (mais recommandé)",
            friend: "Recommandation d'un ami ou collègue",
            internet: "Internet (newsletter, blog, podcast, etc.)",
            search: "Moteur de recherche (Google, Bing, etc.)",
            twitter: "Twitter",
            youtube: "YouTube",
            linkedin: "LinkedIn",
            other: "Autre",
            back: "Retour",
            continue: "Continuer"
        },
        pricing: {
            title: "Plans et Tarifs",
            subtitle: "Choisissez le plan qui correspond à vos besoins",
            footer: "Tous les plans incluent un support client dédié. Contactez-nous pour plus d'informations.",
            error: "Erreur lors du chargement de la configuration. Veuillez réessayer.",
            activateSuccess: "Plan traité avec succès !",
            activateError: "Erreur lors de l'activation du plan : {{message}}",
            activateErrorGeneric: "Erreur lors de l'activation du plan. Veuillez réessayer.",
            note: "Chaque crédit correspond à une étape de processus cartographiée",
            units: {
                currency: "USD",
                currencyPerMonth: "USD/mois",
                credits: "crédits",
                creditsPerMonth: "crédits/mois",
                custom: "Sur mesure",
                unlimited: "Sur mesure",
                oneTime: "ponctuel",
                month: "mois"
            },
            plans: {
                popular: "Populaire",
                free: {
                    name: "Gratuit",
                    description: "Sans expiration, idéal pour explorer",
                    feature1: "{{credits}} crédits, sans expiration",
                    feature2: "Support par e-mail",
                    feature3: "Jusqu'à 15 utilisateurs",
                    button: "Plan gratuit"
                },
                essential: {
                    name: "Essential",
                    description: "Achat ponctuel pour un usage occasionnel",
                    feature1: "{{credits}} crédits, sans expiration",
                    feature2: "Recharge de crédits à la demande",
                    feature3: "Utilisateurs illimités",
                    feature4: "Support e-mail prioritaire",
                    button: "Choisir Essential"
                },
                plus: {
                    name: "Plus",
                    description: "Idéal pour les équipes qui améliorent leurs performances",
                    feature1: "{{credits}} crédits par mois",
                    feature2: "Renouvellement mensuel",
                    feature3: "Utilisateurs illimités",
                    feature4: "SSO et intégration API",
                    feature5: "Customer success manager dédié",
                    button: "Choisir Plus"
                },
                enterprise: {
                    name: "Enterprise",
                    description: "Pour les grandes organisations",
                    feature1: "Volume de crédits personnalisé",
                    feature2: "Utilisateurs illimités",
                    feature3: "Support téléphone et e-mail 24/7",
                    feature4: "Analytique entreprise",
                    feature5: "Intégrations sur mesure",
                    feature6: "Équipe success dédiée",
                    feature7: "Garanties SLA",
                    button: "Contacter les ventes"
                }
            },
            microsoft: {
                title: "Azure Marketplace",
                recommended: "Recommandé",
                shortMessage: "Facturation simplifiée via votre compte Azure existant",
                cta: "Acheter via Azure Marketplace"
            }
        },
        payment: {
            cancel: {
                title: "Paiement Annulé",
                description: "Aucun montant n'a été débité. Vous pouvez reprendre votre achat à tout moment.",
                help: "Besoin d'aide ? Notre équipe est là pour vous accompagner dans votre choix de plan.",
                retryPayment: "Reprendre l'achat",
                gotoDashboard: "Retour au Dashboard",
                contactSupport: "Contacter le support",
                freeAlternative: "Vous pouvez continuer à utiliser {{appName}} gratuitement avec le plan FREE et ses 40 crédits."
            },
            success: {
                title: "Paiement Réussi",
                description: "Votre paiement a été traité avec succès.",
                loading: "Mise à jour de votre solde...",
                newBalance: "💰 Nouveau solde de crédits",
                plan: "Plan",
                creditsAvailable: "Crédits disponibles",
                nextBilling: "Prochain prélèvement",
                plusInfo: "Votre subscription Plus se renouvelle automatiquement chaque mois. Vous pouvez la gérer depuis votre dashboard.",
                topupInfo: "Vos crédits de top-up ont été ajoutés à votre solde existant.",
                gotoDashboard: "Aller au Dashboard",
                createProcess: "Créer un nouveau processus",
                security: "Paiement sécurisé par Stripe - Aucune donnée de carte n'est stockée sur nos serveurs",
                planDescriptions: {
                    essential: "Plan Essential activé avec succès !",
                    plus: "Subscription Plus activée avec succès !",
                    topupEssential: "Top-up Essential réussi !",
                    default: "Paiement traité avec succès !"
                }
            }
        }
    },

    campaigns: {
        confirmDelete: "Êtes-vous sûr de vouloir supprimer cette campagne ? Cette action ne peut pas être annulée.",
        updateError: "Erreur lors de la mise à jour de la campagne",
        updateCampaign: "Mettre à jour la campagne",
        update: "Mettre à jour",
        delete: "Supprimer",
        analysisCompleted: "L'analyse est terminée. Vous pouvez maintenant inviter des collaborateurs pour vous aider à atteindre votre objectif.",
        updateProcesses: "Mettre à jour les processus",
        editProcesses: "Modifier les processus",
        view_aiAssistant: "Assistant IA",
        view_processes: "Gestion des processus",
        view_collaborators: "Gestion des collaborateurs",
        needToSelectACampaign: "Veuillez sélectionner une campagne",
        createProcessesAnalysis: "Arrêter la conversation et créer l'analyse des processus",
        comingSoon: "Bientôt disponible",
        noMessages: "Aucun message trouvé. Commencez la conversation !",
        search: "Rechercher une campagne...",
        processes: "Processus",
        noCampaigns: "Aucune campagne trouvée",
        noResults: "Aucun résultat trouvé",
        namePlaceholder: "Entrer le nom de la campagne...",
        nameRequired: "Le nom est requis",
        name: "Nom",
        createNewCampaign: "Créer une nouvelle campagne",
        industry: "Industrie",
        selectIndustry: "Sélectionner un secteur d'activité",
        createCampaign: "Créer la campagne",
        creating: "Création...",
        close: "Fermer",
        description: "Description",
        descriptionPlaceholder: "Entrer une description détaillée de la campagne...",
        selectCampaign: "Sélectionner ou créer une campagne pour afficher l'assistant IA",
        typeMessage: "Entrer votre message ici",

        todoList: "Etapes de la campagne",
        inProgress: "En cours",
        todoDefinitionObjectives: "Définition objectifs",
        todoInviteCollaborator: "Inviter collaborateur",
        todoInterviewsInProgress: "Interview collaborateurs en cours",
        todoInterviewsCompleted: "Interviews terminées",
        todoMappingsInProgress: "Cartographies en cours de finalisation",
        todoReportAvailable: "Rapport disponible",
        quickActions: "Actions Rapides",
        aiAssistant: "AI Assistant",
        collaborators: "Collaborateurs",
        report: "Rapport",
        processes: "Processus",
        newCampaign: "Nouvelle campagne",
        recentCampaigns: "Campagnes récentes",
        noReportsAvailable: "Aucun rapport disponible",
        suggestedProcesses: "Processus suggérés par l'IA",
        confirmOrModifyProcesses: "Vous pouvez confirmer ou modifier cette liste dans le chat",
        defineObjective: "Définissez votre objectif ou votre campagne",
        objectivePlaceholder: "Ex: Améliorer le processus de recrutement, Optimiser la gestion des commandes...",
        objectiveAnalyzed: "J'ai analysé votre objectif. Voici les processus que je suggère pour l'atteindre :",
        welcomeMessage: "Bonjour ! Je suis votre assistant IA pour la gestion de campagnes. Commençons par définir votre objectif."
    },

    words: {
        danger: "Attention !",
        add: "Ajouter",
        analysis: "Analyses",
        administrator: "Administrateur",
        address: "Adresse",
        alignment: "Alignement",
        answer: "Réponse",
        approve: "Approuver",
        attributes: "Attributs",
        back: "Retour",
        bold: "Gras",
        bottom: "Bas",
        cancel: "Annuler",
        capitalize: "Capitaliser",
        city: "Ville",
        close: "Fermer",
        comments: "Commentaire",
        confirm: "Confirmer",
        copied: "Copié",
        center: "Centrer",
        country: "Pays",
        create: "Créer",
        copy: "Copier",
        done: "Terminé",
        revoke: "Retirer",
        decision: "Décision",
        delete: "Supprimer",
        demote: "Rétrograder",
        description: "Description",
        disApprove: "Rejeter",
        edit: "Modifier",
        edition: "Edition",
        email: "E-mail",
        english: "Anglais",
        end: "Fin",
        export: "Exporter",
        error: "Erreur",
        faq: "FAQ",
        file: "Fichier",
        filter: "Filtre",
        finish: "Terminer",
        french: "Français",
        from: "De",
        help: "Aide",
        home: "Accueil",
        hello: "Salut",
        hide: "cacher",
        grant: "Accorder",
        information: "Information",
        improve: "Améliorer",
        invite: "Inviter",
        interview: "Entretien",
        diagram: "Diagramme",
        diagrams: "Diagrammes",
        inviteAApprover: "Inviter un approbateur",
        italic: "Italique",
        languages: "Langues",
        left: "Gauche",
        link: "Lien",
        light: "Léger",
        line: "Ligne",
        lowercase: "Minuscules",
        loading: "Chargement...",
        menu: "Menu",
        map: "Cartographie",
        maps: "Cartographies",
        me: "Moi",
        message: "Décrivez votre demande ici",
        name: "Prénom et Nom",
        nameFolder: "Nom",
        new: "Nouveau",
        no: "Non",
        normal: "Normal",
        objectifProcess: "Objectif du processus",
        or: "OU",
        organize: "Déplacer le dossier",
        past: "Coler",
        process: 'Processus',
        owner: "Propriétaire",
        processing: "Traitement",
        promote: "Promouvoir",
        proces: "Tâche",
        publish: "Publier",
        question: "Question",
        refresh: "Rafraîchir",
        rename: "Renommer",
        remove: "Retirer",
        reminder: 'Replace',
        requestApproval: "Demande d'approbation",
        replace: "Remplacer",
        right: "Droit",
        role: "Rôle",
        status: "Statut",
        start: "Début",
        note: "Post-it",
        linkedTo: "Lié à",
        linkTask: "Lier à la tâche",
        unlinkTask: "Délier la tâche",
        linkTaskFirst: "Liez d'abord une tâche",
        linkAttribute: "Lier à l'attribut",
        unlinkAttribute: "Délier l'attribut",
        linkedAttributes: "Attributs liés",
        none: "Aucune",
        save: "Sauvegarder",
        saveAs: "Sauvegarder Sous",
        you: "vous",
        search: "Recherche",
        searching: "Recherche",
        noResults: "Aucun résultat",
        selected: "Sélectionnée",
        selecteds: "Sélectionnées",
        send: "Envoyer",
        share: "Partager",
        subject: "Sujet",
        text: "Texte",
        to: "Pour",
        top: "Haut",
        token: "Token",
        uppercase: "Majuscules",
        view: "Affichage",
        viewMore: "Voir plus",
        showLess: "Voir moins",
        thank: "Merci",
        yes: "Oui",
        saving: "Sauvegarde...",
        tip: "Conseil",
        characters: "caractères",
        shareLink: "Lien de partage",
        titleRequired: "Le titre est obligatoire",
        descriptionRequired: "La description est obligatoire",
        settings: "Paramètres",
        rename: "Renommer",
        delete: "Supprimer",
        interviews: "Entretiens",
        insight: "Analyse",
        insights: "Analyses",
        generate: "Générer",
        generated: "Générés",
        generateNew: "Générer nouveau",
        getNewInsight: "Obtenir un insight",
        runNewAnalysis: "Lancer nouvelle analyse",
        analyze: "Analyser",
        addRole: "Ajouter un rôle",
        newInterview: "Nouvel entretien",
        quickActions: "Actions rapides",
        progress: "Progrès",
        scopeSet: "Périmètre défini",
        of: "sur",
        completed: "terminés",
        library: "Bibliothèque",
        businessPlanHint: "Débloquez des versions de diagrammes illimitées avec le plan Business."
    }
    ,
    layer: {
        connectYourProcessMaps: "Connectez vos cartographies de processus",
        hiddenProperties: "Propriétés masquées",
        noHiddenpropertiesAvailable: "Pas de propriétés masquées",
        layerSettings: "Paramètres des attributs",
        selectProcess: "Sélectionner un processus",
        selectMap: "Sélectionner une cartographie",
        searchProcesses: "Rechercher un processus",

        block: {
            leadtime: "Temps de cycle",
            defectrate: "Taux de défauts",
            itsystem: "Système IT",
            cost: "Coût",
            carbonfootprint: "Empreinte carbone",
            headcount: "Effectif",
            irritantsandimprovements: "Irritants",
            risksandcontrols: "Risques et contrôles",
            relateddocuments: "Documents associés",
            failuremode: "Modes de défaillance",
            link: "Lien",
            wbs: "WBS",
        },
        line: {
            inventory: "Stock",
            transfertime: "Temps de transfert",
            input: "Entrées",
            output: "Sorties",
            link: "Lien",

        },
        enterUrl: "Entrez une URL valide",
        timeUnit: "Unité",
        timeUnits: {
            min: "min",
            h: "h",
            d: "j",
            s: "s",
        },
    },

    // Messages professionnels pour CompanyAnalysis
    companyAnalysis: {
        // Messages de succès
        analysisSaved: "Analyse sauvegardée avec succès",
        analysisLoaded: "Analyse chargée avec succès",
        draftRestored: "Brouillon restauré avec succès",

        // Messages d'erreur professionnels
        errorSaving: "Erreur lors de la sauvegarde de l'analyse",
        errorLoading: "Impossible de charger l'analyse",
        errorSubmitting: "Erreur lors de l'envoi du prompt",
        errorNoDocuments: "Veuillez sélectionner au moins un document avant de commencer l'analyse",
        errorNoMapOrCollection: "Veuillez sélectionner au moins une cartographie ou une collecte",
        errorEmptyPrompt: "Veuillez saisir une question ou une instruction",
        errorNoAnalysis: "Aucune analyse à sauvegarder",
        errorSession: "Session expirée. Veuillez vous reconnecter",
        insightsLinkedCollectionInaccessible:
            "Cette cartographie est liée à une collecte ({{names}}) à laquelle vous n'avez pas accès. L'analyse portera sur la cartographie uniquement.",

        // Messages d'information
        unsavedDraft: "Brouillon non sauvegardé",
        analysisInProgress: "Analyse en cours...",
        selectDocuments: "Sélectionnez au moins un document pour commencer",

        // Confirmations
        confirmNewAnalysis: "Vous avez un brouillon non sauvegardé. Voulez-vous le sauvegarder avant de commencer une nouvelle analyse ?",
        confirmDiscard: "Êtes-vous sûr de vouloir abandonner votre brouillon ?",

        // Workflow
        step1: "Sélection des documents",
        step2: "Analyse en cours",
        step3: "Sauvegarde de l'analyse",
        step4: "Consultation des résultats",

        heroSubtitle: "Choisissez un point de départ ou décrivez ce que vous cherchez.",

        // Panneau droit — checklist et hints
        checklistAddDocument: "Ajouter un processus",
        checklistAskQuestion: "Poser une question",
        checklistSave: "Sauvegarder l'analyse",
        rightPanelHintEmpty: "Sélectionnez un processus et posez une question pour générer un insight.",
        rightPanelHintResults: "Vos résultats sont prêts. Posez une question de suivi ou sauvegardez l'analyse.",

        // Avant de commencer — étapes panneau droit
        beforeYouStart: "Avant de commencer",
        step1Title: "Sélectionnez votre/vos processus",
        step1Desc: "Choisissez un ou plusieurs processus à analyser.",
        step2Title: "Importez vos documents (optionnel)",
        step2Desc: "Ajoutez des fichiers pertinents pour plus de contexte.",
        step3Title: "Préparez votre cartographie",
        step3Desc: "Vérifiez, ajustez et enrichissez votre cartographie avec des attributs pour de meilleurs résultats.",
        step4Title: "Formulez votre requête",
        step4Desc: "Décrivez ce que vous souhaitez analyser ou générer.",
        step5Title: "Consultez et agissez",
        step5Desc: "Explorez vos résultats et passez à l'action.",
        espaceAnnonces: "Espace Annonces"
    },

    // Système de tutoriel
    tutorial: {
        startTutorial: "Démarrer le tutoriel",
        buttons: {
            back: "Retour",
            close: "Fermer",
            finish: "Terminer",
            next: "Suivant",
            open: "Ouvrir",
            skip: "Passer",
            last: "Terminer"
        },
        labels: {
            buttonNext: "Suivant",
            buttonBack: "Retour",
            buttonSkip: "Passer",
            close: "Fermer",
            last: "Terminer",
            open: "Ouvrir",
            skip: "Passer"
        },
        aria: {
            close: "Fermer le tutoriel",
            skip: "Passer cette étape",
            next: "Étape suivante",
            back: "Étape précédente",
            last: "Terminer le tutoriel"
        },
        joyride: {
            close: "Fermer",
            last: "Terminer",
            next: "Suivant",
            open: "Ouvrir",
            skip: "Passer",
            back: "Retour"
        },
        stepCounter: {
            step: "Étape",
            of: "sur",
            stepXofY: "Étape {{step}} sur {{total}}"
        },
        home: {
            pageName: "Accueil",
            welcome: "Bienvenue sur {{appName}} ! Cette plateforme vous aide à transformer vos objectifs en actions, ancrées dans votre réalité. Explorons ensemble les fonctionnalités principales pour l'excellence opérationnelle.",
            welcomeTitle: "Bienvenue sur {{appName}}",
            discoverProcess: "Transformez le travail réel en une cartographie claire. Interrogez votre équipe, importez un fichier ou dessinez — chaque méthode mène au même diagramme modifiable.",
            discoverProcessTitle: "Créer un diagramme",
            generateDiagram: "Cliquez ici pour créer un diagramme. Choisissez entretien, import ou dessin à l'étape suivante.",
            generateDiagramTitle: "Créer un diagramme",
            collectData: "Menez une enquête guidée par l'IA pour enrichir une cartographie de processus ou recueillir des informations structurées auprès de votre équipe.",
            collectDataTitle: "Collecter des données",
            analyzeOptimize: "Utilisez l'analyse alimentée par l'IA pour identifier les gaspillages, réduire les coûts et améliorer l'efficacité de votre équipe.",
            analyzeOptimizeTitle: "Analyse IA des processus",
            designFuture: "Vous avez un objectif business et voulez savoir comment l'atteindre ? Notre chef de projet IA vous guide de l'intention à l'action en se concentrant sur l'impact.",
            designFutureTitle: "Gestion de projet IA",
            recentProcesses: "Pour vous aider à démarrer, nous avons préchargé un processus exemple afin que vous puissiez voir les résultats à attendre.",
            recentProcessesTitle: "Processus Exemple"
        },
        processCreate: {
            pageName: "Création de processus",
            welcome: "Créons ensemble votre premier projet de cartographie de processus ! Cette interface vous guidera pour documenter vos processus et identifier les opportunités d'amélioration.",
            welcomeTitle: "Nouveau projet de cartographie",
            processName: "Saisissez un nom descriptif pour votre processus. Choisissez quelque chose de clair qui identifie le workflow que vous cartographiez.",
            processNameTitle: "Nom du processus",
            processDescription: "Fournissez une brève description de ce que ce processus accomplit. Cela aide les membres de l'équipe à comprendre l'objectif.",
            processDescriptionTitle: "Description",
            processSteps: "Maintenant, décrivez les étapes principales de votre processus.",
            processStepsTitle: "Étapes du processus",
            processIndustry: "Sélectionnez le secteur d'activité qui correspond le mieux à votre processus. Cela aide notre IA à fournir des suggestions plus pertinentes.",
            processIndustryTitle: "Sélection du secteur",
            processLanguage: "Choisissez la langue pour la documentation de votre processus. Cela affecte les réponses et suggestions de l'IA.",
            processLanguageTitle: "Sélection de la langue",
            processType: "Sélectionnez comment vous voulez créer votre processus. Interview guidée par l'IA ou création manuelle de diagramme.",
            processTypeTitle: "Méthode de création",
            submitProcess: "Parfait ! Cliquez ici pour créer votre processus.",
            submitProcessTitle: "Créer le processus",
            createButton: "Cliquez ici pour créer votre processus et commencer le workflow de mapping. Vous serez guidé à travers les prochaines étapes.",
            createButtonTitle: "Créer le processus"
        },
        campaigns: {
            pageName: "Campagnes",
            welcome: "Bienvenue dans l'espace Campagnes ! Ici, vous pouvez concevoir et gérer vos processus futurs avec l'aide de l'intelligence artificielle.",
            welcomeTitle: "Découverte des Campagnes",
            navigation: "Cette barre latérale vous permet de naviguer entre vos différentes campagnes. Vous pouvez créer de nouvelles campagnes ou sélectionner une campagne existante.",
            navigationTitle: "Navigation des campagnes",
            mainView: "Cette zone centrale affiche le contenu principal de votre campagne sélectionnée. C'est ici que vous interagirez avec les outils de conception.",
            mainViewTitle: "Vue principale",
            aiAssistant: "L'assistant IA vous aide à définir les objectifs et à concevoir votre processus futur. Posez-lui des questions et laissez-vous guider !",
            aiAssistantTitle: "Assistant IA",
            sidebar: "Cette barre latérale droite contient les outils et informations contextuelles pour votre campagne active.",
            sidebarTitle: "Panneau d'outils",
            status: "Le statut de votre campagne vous indique où vous en êtes dans le processus de conception et quelles sont les prochaines étapes.",
            statusTitle: "Statut de la campagne",
            viewTabs: "Ces onglets vous permettent de basculer entre différentes vues : Assistant IA, Processus, Collaborateurs et Rapports.",
            viewTabsTitle: "Onglets de navigation"
        },
        analysis: {
            pageName: "Analyse",
            welcome: "Bienvenue dans l'analyse alimentée par l'IA ! Ici, vous pouvez analyser vos processus et opérations pour identifier les gaspillages, réduire les coûts et améliorer l'efficacité de votre équipe.",
            welcomeTitle: "Analyse IA des processus",
            sidebar: "Cette barre latérale vous permet de gérer vos documents, créer de nouvelles analyses et naviguer entre vos analyses sauvegardées.",
            sidebarTitle: "Navigation des analyses",
            documents: "Ici vous pouvez ajouter des documents et des processus à analyser. Cliquez sur 'Nouveau Document' pour commencer.",
            documentsTitle: "Gestion des documents",
            reports: "Cette zone affiche vos rapports d'analyse générés par l'IA. Les graphiques et visualisations vous aident à comprendre vos données.",
            reportsTitle: "Rapports d'analyse",
            suggestions: "Ces suggestions vous proposent des analyses prêtes à utiliser. Cliquez sur une suggestion pour lancer l'analyse correspondante.",
            suggestionsTitle: "Suggestions d'analyse",
            input: "Utilisez cette zone pour poser des questions spécifiques sur vos données ou demander des analyses personnalisées à l'IA.",
            inputTitle: "Zone de saisie",
            charts: "Les graphiques et visualisations générés vous permettent de mieux comprendre vos processus et identifier les opportunités d'amélioration.",
            chartsTitle: "Graphiques et données",
            newDocumentTitle: "Gestion des documents",
            newDocument: "Ici, vous pouvez ajouter des documents et des processus à analyser. Cliquez sur « Nouveau document » pour commencer."
        },
        flowchart: {
            pageName: "Éditeur de diagrammes",
            welcome: "Visualisez et modifiez vos diagrammes générés par l'IA.",
            welcomeTitle: "Éditeur de diagrammes",
            canvas: "Votre diagramme s'affiche ici. Cliquez sur les éléments pour les modifier.",
            canvasTitle: "Zone de diagramme",
            processOwner: "Les Process Owners ont accès à des commandes spéciales pour contrôler qui peut éditer et ce qui peut être modifié.",
            processOwnerTitle: "Commandes Process Owner",
            tools: "Utilisez ces outils pour zoomer, éditer et gérer les calques de données.",
            toolsTitle: "Outils d'édition",
            export: "Utilisez ce menu pour exporter le diagramme et les transcriptions d'entretiens dans le format de votre choix.",
            exportTitle: "Exporter et Partager",
            editMode: "Utilisez le glisser-déposer pour ajouter des formes depuis ici vers le canevas de dessin.",
            editModeTitle: "Mode Édition",
            attributes: "Cliquez sur une étape puis sur l'icône Information pour ajouter des attributs (coûts, temps, risques).",
            attributesTitle: "Ajouter des attributs",
            analysis: "Obtenez des insights IA automatiques et des recommandations d'optimisation.",
            analysisTitle: "Analyse IA"
        },
        admin: {
            pageName: "Panneau d'administration",
            welcome: "Bienvenue dans votre interface d'administration.Ce guide rapide va vous faire découvrir les principales fonctionnalités pour gérer votre espace  de travail et suivre votre consommation.",
            welcomeTitle: "Panneau d'administration",
            overviewMerged: "Cette section vous donne un aperçu complet de votre tableau de bord : métriques clés (utilisateurs actifs, crédits disponibles), graphiques de consommation mensuelle, et gestion détaillée de vos crédits avec quota et report. Surveillez ces indicateurs pour optimiser votre utilisation et votre plan d'abonnement.",
            overviewMergedTitle: "Vue d'ensemble et métriques",
            actions: "Ce panneau vous permet d'effectuer des actions rapides : recharger des crédits, consulter l'historique et gérer les paiements.",
            actionsTitle: "Actions rapides",
            subscription: "Gérez votre abonnement, changez de plan, consultez les factures et accédez au portail client Stripe.",
            subscriptionTitle: "Gestion de l'abonnement",
            administrators: "Cet onglet vous permet de gérer les administrateurs de votre organisation. Vous pouvez ajouter, modifier ou supprimer des droits d'administration pour contrôler qui a accès aux paramètres avancés de la plateforme.",
            administratorsTitle: "Gestion des administrateurs",
            library: "Accédez à votre bibliothèque de processus depuis cet onglet. Vous y trouverez tous vos projets de cartographie, diagrammes et processus documentés. Organisez, recherchez et gérez facilement l'ensemble de vos workflows.",
            libraryTitle: "Bibliothèque de processus",
            users: "Invitez de nouveaux utilisateurs, gérez les permissions et suivez l'activité de votre équipe depuis ce panneau.",
            usersTitle: "Gestion des utilisateurs"
        },
        onboarding: {
            pageName: "Connexion",
            welcome: "Bienvenue sur {{appName}} ! L'IA pour l'Excellence Opérationnelle. Ce guide est conçu pour vous aider à démarrer rapidement sur la plateforme et explorer ses principales fonctionnalités.",
            welcomeTitle: "Bienvenue sur {{appName}}",
            loginForm: "Saisissez votre email professionnel et votre mot de passe pour accéder à la plateforme. Vos identifiants sont sécurisés et chiffrés.",
            loginFormTitle: "Formulaire de connexion",
            signupLink: "Nouveau sur {{appName}} ? Cliquez ici pour créer votre compte. Vous recevrez un email de vérification pour activer votre compte.",
            signupLinkTitle: "Créer un compte",
            forgotPassword: "Mot de passe oublié ? Cliquez sur ce lien pour recevoir un email de réinitialisation sécurisé.",
            forgotPasswordTitle: "Récupération de mot de passe",
            emailVerification: "Vérifiez votre boîte email et cliquez sur le lien de confirmation pour activer votre compte {{appName}}.",
            emailVerificationTitle: "Vérification email"
        },
        library: {
            pageName: "Bibliothèque",
            welcome: "Bienvenue dans la bibliothèque ! Organisez vos projets par client, programme ou département. Créez des dossiers et déplacez vos projets pour une meilleure organisation.",
            welcomeTitle: "Gestion de la bibliothèque",
            projects: "Ici vous voyez tous vos projets. Cliquez sur un projet pour l'ouvrir ou utilisez le menu contextuel (3 points) pour plus d'options.",
            projectsTitle: "Vos projets",
            folders: "Organisez vos projets dans des dossiers. Par défaut, tous les projets sont dans le dossier principal.",
            foldersTitle: "Dossiers d'organisation",
            createFolder: "Cliquez sur 'Nouveau dossier' pour créer un dossier et organiser vos projets par catégorie.",
            createFolderTitle: "Créer un dossier",
            moveProject: "Utilisez le menu contextuel (3 points) sur un projet pour le déplacer vers un autre dossier.",
            moveProjectTitle: "Déplacer un projet",
            search: "Utilisez la fonction de recherche pour localiser rapidement un projet spécifique dans votre bibliothèque.",
            searchTitle: "Recherche de projets"
        },
        support: {
            pageName: "Support",
            welcome: "Accédez facilement à l'aide et au support {{appName}}. Trouvez des ressources, contactez l'assistance et obtenez de l'aide pour utiliser la plateforme.",
            welcomeTitle: "Support et aide",
            helpMenu: "Cliquez sur 'Aide' dans l'en-tête pour accéder aux ressources d'aide, disponible depuis la plupart des pages.",
            helpMenuTitle: "Menu d'aide",
            contactForm: "Utilisez le formulaire de contact pour nous envoyer vos questions ou problèmes techniques.",
            contactFormTitle: "Formulaire de contact",
            supportEmail: "Pour un support direct, contactez-nous à {{supportEmail}} pour une assistance personnalisée.",
            supportEmailTitle: "Email de support"
        },
        participants: {
            pageName: "Gestion des participants",
            welcome: "Gérez les participants de vos interviews.",
            welcomeTitle: "Gestion des participants",
            listAndStatus: "Consultez tous les participants avec leur statut (Invité, Actif). Cliquez sur les trois points (⋮) pour plus d'options.",
            listAndStatusTitle: "Liste et statuts",
            menu: "Accédez aux options : remplacer, envoyer des rappels ou consulter les transcripts.",
            menuTitle: "Options de gestion",
            replace: "Remplacez un participant si nécessaire.",
            replaceTitle: "Remplacer",
            reminder: "Envoyez un rappel pour relancer les interviews incomplètes.",
            reminderTitle: "Rappels"
        },
        sampleProcess: {
            pageName: "Processus Exemple",
            welcome: "Cet exemple de processus d'intégration des employés illustre comment {{appName}} capture les étapes, les rôles et les passages de relais.",
            welcomeTitle: "Démonstration",
            interview: "Explorez l'interview du Process Owner et des 5 stakeholders.",
            interviewTitle: "Phase Interview",
            navigationMapping: "Cliquez pour voir le diagramme swimlane généré par l'IA.",
            navigationMappingTitle: "Vers la Cartographie",
            mapping: "5 lanes, 12 étapes. Cartographie générée automatiquement.",
            mappingTitle: "Diagramme Swimlane",
            navigationAnalysis: "Cliquez pour voir les insights IA du processus.",
            navigationAnalysisTitle: "Vers l'Analyse",
            analysis: "Goulots d'étranglement identifiés et recommandations d'optimisation.",
            analysisTitle: "Analyse IA"
        },

        // =============================================================================
        // [APP GUIDANCE] Tutoriel interactif processus Employee Onboarding
        // =============================================================================
        appGuidance: {
            welcome: "Cet exemple de processus d'intégration des employés illustre comment {{appName}} capture les étapes, les rôles et les passages de relais.",
            welcomeTitle: "Découvrez {{appName}}",
            interview: "La barre latérale vous permet d'accéder aux commandes, de voir qui collabore et de consulter les résultats tels que les cartes et les analyses.",
            interviewTitle: "Aperçu de la barre latérale",
            navigationMapping: "Cliquez pour voir le diagramme swimlane généré.",
            navigationMappingTitle: "Vers la Cartographie",
            mapping: "Pas besoin de dessiner des cases manuellement ! À partir de l'entretien que vous venez de voir, {{appName}} a généré ce flux visuel complexe. Cliquez ici pour accéder à la cartographie.",
            mappingTitle: "Diagrammes automatisés",
            navigationAnalysis: "Cliquez pour voir l'analyse IA du processus.",
            navigationAnalysisTitle: "Vers l'Analyse",
            analysisCta: "Goulots identifiés et recommandations. Créez maintenant votre propre processus !",
            analysisCtaTitle: "Analyse & Action",
            analysisCtaButton: "Créer votre propre processus",
            analysisCtaButtonTitle: "Félicitations ! Vous êtes maintenant prêt à utiliser {{appName}} pour transformer vos opérations commerciales.",
            interviewAction: "Il s'agit d'une conversation hypothétique entre notre interviewer IA et un utilisateur. Prêtez attention à la séquence et aux suivis.",
            interviewActionTitle: "L'interviewer IA en action"
        }
    },

    popupMessage: {
        deleteOwnerMessages: "Cette action est irréversible. Tous les messages à partir de ce point seront supprimés.\n \n Si vous avez invité des contributeurs après ce point, leurs entretiens seront également supprimés définitivement.",
        deleteStakeholderMessages: "Cette action est irréversible. Tous les messages à partir de ce point seront supprimés définitivement.",
        finalConfirmation: "Confirmation finale",
        deleteProcess: "Pour confirmer la suppression de tous les entretiens et contributions, veuillez saisir la phrase suivante : ",
        deleteInterviewsOf: "Supprimer les interviews de ",
        typeThePhraseHere: "Saisissez la phrase de confirmation ici",
        deleteAll: "Tout supprimer!",
        textDontMatch: "Les textes ne correspondent pas !"
    },

    checklist: {
        setScope: "Définir le périmètre",
        inviteStakeholders: "Inviter les parties prenantes",
        interviewsInProgress: "Interviews en cours",
        interviewsCompleted: "Interviews terminées",
        discoveryCompleted: "Cartographies disponibles",
        mapTaskSequence: "Cartographier la séquence des tâches",
        mapInterdependencies: "Cartographier les interdépendances entre rôles",
        identifyDecisionPoints: "Identifier les points de décision",
        highlightIrritants: "Mettre en évidence les irritants",
        reviewAlignment: "Réviser l'alignement",
        interviewCompleted: "Interview terminée"
    },

    whatsNew: {
        badge: "Nouveautés",
        period: "Août 2026",
        title: "🚀 Nouveautés sur {{appName}} AI",
        subtitle: "Un ensemble de mises à jour pour cartographier plus vite et travailler plus efficacement.",
        cta: "Essayer {{appName}} Canvas",
        collectSetupTitle: "Facile à configurer",
        collectSetupDesc: "Décrivez votre objectif et {{appName}} Collect conçoit les questions pour vous.",
        collectAdaptTitle: "Adapté à chaque partie prenante",
        collectAdaptDesc: "Les questions s'ajustent automatiquement en fonction du rôle et des réponses précédentes. Chaque personne ne voit que ce qui la concerne.",
        collectVoiceTitle: "Réponse vocale",
        collectVoiceDesc: "Les parties prenantes peuvent répondre à la voix, pour une participation plus rapide et plus naturelle.",
        collectAvailable: "Disponible dès maintenant pour tous les utilisateurs.",
        microsoftAuthTitle: "Authentification Microsoft",
        microsoftAuthDesc: "Connectez-vous et invitez vos collègues en toute sécurité avec leur compte Microsoft 365 ou Azure AD. Simplifiez l'accès à {{appName}} pour toute votre organisation.",
        coOwnerTitle: "Co-propriétaire de processus",
        coOwnerDesc: "Vous pouvez désormais partager la propriété d'un processus avec un collègue. Depuis votre page d'accueil, ouvrez le menu contextuel sur la carte du processus concerné et accordez des droits étendus en quelques clics.",
        interfaceTitle: "Interface repensée",
        interfaceDesc: "Un nouveau design avec le mode clair activé.",
        voiceTitle: "Mode vocal pour les contributeurs",
        voiceDesc: "Conduisez vos entretiens en mode mains libres grâce au nouveau mode vocal. À tester absolument.",
        stakeholderTitle: "Détection intelligente des parties prenantes",
        stakeholderDesc: "Les parties prenantes supplémentaires sont désormais détectées automatiquement à partir des entretiens, et les propriétaires de processus sont notifiés par email.",
        painPointTitle: "Points de friction en Post-it",
        painPointDesc: "Les points de friction extraits des entretiens sont automatiquement chargés dans des Post-it notes, prêts à être traités.",
        canvasTitle: "{{appName}} Canvas",
        canvasDesc: "Dessinez vos cartes de processus manuellement, avec une liberté totale.",
        bpmnTitle: "Symboles BPMN",
        bpmnDesc: "Modélisez vos processus avec la notation standard BPMN.",
        onboardingTitle: "Nouveau parcours d'intégration",
        onboardingDesc: "Les nouveaux comptes prennent en main l'application plus rapidement grâce à une expérience guidée.",
        homepageTitle: "Page d'accueil repensée",
        homepageDesc: "Un nouveau design pour un démarrage plus clair et plus intuitif.",
        teamControlsTitle: "Contrôles d'équipe renforcés",
        teamControlsDesc: "Les propriétaires de processus peuvent désormais gérer leurs équipes avec plus de précision.",
        searchTitle: "Recherche améliorée",
        searchDesc: "Retrouvez vos processus par nom ou par les rôles qu'ils impliquent."
    },

    microsoft: {
        marketplace_title: "Place de marché Azure",
        logo_alt: "{{appName}}",
        configuring: "Configuration de votre compte...",
        thank_you: "Merci d'avoir acheté {{appName}} via Azure Marketplace.",
        shortMessage: "Facturation simplifiée via votre compte Azure existant",
        activating: "Activation de votre abonnement...",
        activating_retry: "Nouvelle tentative d'activation ({{attempt}}/{{max}})…",
        success: "{{credits}} crédits ajoutés à votre compte !",
        activation_success: "Activation réussie !",
        sso_required_title: "Connectez-vous pour activer",
        connecting_famla: "Connexion à votre compte {{appName}}...",
        integration_label: "Intégration",
        credits_added: "crédits ajoutés",
        purchaseSuccessToast: "{{credits}} crédits ajoutés via Azure Marketplace !",
        redirecting: "Redirection vers votre tableau de bord...",
        activation_error: "Erreur d'activation",
        contact_support: "Contacter le support",
        auto_redirect: "Vous serez automatiquement redirigé.",
        click_here: "cliquez ici",
        free_starter_awaiting_sso: "Connectez-vous avec Microsoft pour activer votre abonnement Free. Pour aller plus loin, passez au plan Plus et débloquez plus de crédits.",
        free_starter_upgrade_message: "Votre plan Free est activé. Passez au plan supérieur (Plus) pour bénéficier de plus de crédits et de fonctionnalités.",
        free_starter_redirecting: "Redirection vers votre tableau de bord...",
        workspace_required: "Connectez-vous via Microsoft SSO pour créer votre workspace, puis réessayez l'activation.",
        tenant_mismatch: "Le compte Microsoft utilisé ne correspond pas à l'organisation qui a souscrit l'offre.",
        retry_activation: "Réessayer l'activation",
        connect_microsoft: "Se connecter avec Microsoft",
        reconnect_microsoft: "Se reconnecter avec le bon compte",
        view_plans: "Voir les plans",
        error: {
            no_token: "Le jeton Microsoft est manquant",
            not_authenticated: "Vous devez être connecté",
            activation_failed: "Échec de l'activation de l'abonnement. Veuillez contacter le support.",
            free_starter_already_claimed: "Vous avez déjà activé le forfait Free Starter. Passez au forfait Plus pour obtenir plus de crédits !",
            activation_retry: "L'activation prend plus de temps que prévu. Réessayez dans quelques instants.",
            company_mismatch: "La société de votre session ne correspond pas à celle de cette souscription.",
            token_expired: "Le jeton Marketplace est invalide ou a expiré. Recommencez depuis Azure Marketplace ou contactez le support."
        }
    },

    office: {
        auth: {
            signInPrompt: "Connectez-vous avec votre compte Microsoft pour utiliser Famla.",
            signInButton: "Se connecter avec Microsoft",
            signInRequired: "Veuillez vous connecter avec Microsoft pour continuer.",
            signInPromptEmail: "Connectez-vous avec votre e-mail et mot de passe Famla.",
            signInButtonEmail: "Se connecter avec e-mail",
            signInWithMicrosoftSecondary: "Se connecter avec Microsoft",
            emailDialogTitle: "Connexion à Famla",
            emailDialogSubtitle: "Utilisez votre e-mail et mot de passe Famla.",
            emailNotVerified: "Veuillez vérifier votre adresse e-mail avant de vous connecter.",
            corporateSsoRequired: "Les comptes corporate doivent se connecter via le portail SSO.",
            emailSignInFailed: "Échec de la connexion. Veuillez réessayer."
        },
        sidebar: {
            notAvailable: "Office non disponible",
            notAvailableDesc: "Cette barre latérale doit être ouverte depuis Microsoft Office.",
            readingContext: "Contexte de lecture",
            loading: "Chargement...",
            noContext: "Aucun contexte disponible",
            askAboutProcess: "Poser une question sur ce processus",
            flagPainPoint: "Signaler un point de friction",
            emptyThread: "Sélectionnez une action ci-dessus pour commencer.",
            emptyThreadHint: "Posez une question ou signalez un point de friction sur cet e-mail.",
            inputPlaceholder: "Posez une question ou décrivez un irritant",
            send: "Envoyer",
            generateMap: "Générer une cartographie complète dans Famla",
            handoffLoading: "Création de la session...",
            handoffError: "Échec de la création de la session de transfert",
            desktopLaunching: "Ouverture de l'application Microsoft desktop...",
            desktopLaunchBlocked: "Impossible d'ouvrir l'application desktop automatiquement. Veuillez l'ouvrir manuellement.",
            modeQa: "Posez-moi n'importe quelle question sur ce processus.",
            modeAndon: "Décrivez le problème ou le point de friction rencontré.",
            mapWelcome: "Contexte capturé. Je vais transférer vers l'application web Famla et précharger le générateur document-to-map.",
            andonWelcome: "Vous signalez un point de friction. En une phrase, quel est le problème ?",
            contextCapturedTitle: "Contexte capturé",
            contextCapturedBody: "Ouverture de l'application web Famla avec le générateur document-to-map préchargé.",
            openWebApp: "Ouvrir l'application web Famla",
            andonConfirm: "Votre point de friction a été signalé. Le responsable du processus et les administrateurs ont été notifiés via Teams et email.",
            andonSuccess: "Point de friction signalé avec succès",
            error: "Une erreur s'est produite. Veuillez réessayer.",
            errorToast: "Échec de la requête",
            sourceChipClick: "Ouverture de la source dans un nouvel onglet...",
            generalKnowledge: "Basé sur les bonnes pratiques générales, pas sur un enregistrement de processus spécifique : "
        },
        handoff: {
            loading: "Chargement de votre contexte Office...",
            errorTitle: "Session de transfert indisponible",
            missingSession: "Aucune session de transfert n'a été fournie.",
            errorDesc: "Cette session a peut-être expiré ou a déjà été utilisée.",
            authRequired: "Connectez-vous à Famla pour charger cette session de transfert.",
            title: "Créer une cartographie à partir d'Office",
            subtitle: "Votre contexte {{hostApp}} a été importé. Vérifiez et complétez le formulaire ci-dessous.",
            returnToHost: "Retour vers {{hostApp}}",
            returnChoose: "Retour vers {{hostApp}}",
            returnWeb: "Ouvrir dans le navigateur",
            returnDesktop: "Ouvrir l'application desktop",
            desktopLaunching: "Ouverture de {{hostApp}} desktop...",
            desktopTryAnyway: "{{hostApp}} desktop n'est peut-être pas installé sur ce système. Si rien ne s'ouvre, utilisez l'option navigateur.",
            desktopHint: "Nécessite {{hostApp}} desktop (Windows/Mac)",
            desktopHintSupported: "Ouvre {{hostApp}} installé sur votre ordinateur",
            threadContext: "Conversation Office"
        }
    },

    andon: {
        hub: {
            title: "Signalements Andon",
            loading: "Chargement...",
            empty: "Aucun signalement n'a encore été émis.",
            loadError: "Échec du chargement des signalements Andon",
            colOrigin: "Origine",
            colUser: "Utilisateur",
            colMessage: "Message",
            colStatus: "Statut",
            colDate: "Date",
            view: "Voir",
            status: {
                pending: "En attente",
                acknowledged: "Pris en compte",
                resolved: "Résolu"
            }
        },
        detail: {
            title: "Détail du signalement",
            backToList: "Retour au hub Andon",
            loading: "Chargement...",
            notFound: "Signalement introuvable.",
            loadError: "Échec du chargement du signalement",
            status: "Statut",
            origin: "Origine (application hôte)",
            user: "Signalé par",
            message: "Message",
            context: "Contexte",
            subject: "Sujet",
            timestamps: "Horodatages",
            created: "Créé",
            acknowledged: "Pris en compte",
            resolved: "Résolu",
            notified: "Notifications envoyées",
            resolutionNote: "Note de résolution",
            acknowledgeBtn: "Prendre en compte",
            acknowledgeSuccess: "Signalement pris en compte",
            acknowledgeError: "Échec de la prise en compte",
            resolveBtn: "Résoudre",
            resolveSuccess: "Signalement résolu",
            resolveError: "Échec de la résolution",
            resolveNoteRequired: "Veuillez ajouter une note de résolution",
            resolveNotePlaceholder: "Ajouter une note de résolution..."
        }
    }

}



export default fr